export const Icons = {
  AddList: require('assets/icon/add-list.svg').ReactComponent,
  Activity: require('assets/icon/activity.svg').ReactComponent,
  ActivityHeart: require('assets/icon/activity-heart.svg').ReactComponent,
  Anchor: require('assets/icon/anchor.svg').ReactComponent,
  Archive: require('assets/icon/archive.svg').ReactComponent,
  Asterisk01: require('assets/icon/asterisk-01.svg').ReactComponent,
  Asterisk02: require('assets/icon/asterisk-02.svg').ReactComponent,
  AtSign: require('assets/icon/at-sign.svg').ReactComponent,
  Bookmark: require('assets/icon/bookmark.svg').ReactComponent,
  BookmarkAdd: require('assets/icon/bookmark-add.svg').ReactComponent,
  BookmarkCheck: require('assets/icon/bookmark-check.svg').ReactComponent,
  BookmarkMinus: require('assets/icon/bookmark-minus.svg').ReactComponent,
  BookmarkX: require('assets/icon/bookmark-x.svg').ReactComponent,
  Building01: require('assets/icon/building-01.svg').ReactComponent,
  Building02: require('assets/icon/building-02.svg').ReactComponent,
  Building03: require('assets/icon/building-03.svg').ReactComponent,
  Building04: require('assets/icon/building-04.svg').ReactComponent,
  Building05: require('assets/icon/building-05.svg').ReactComponent,
  Building06: require('assets/icon/building-06.svg').ReactComponent,
  Building07: require('assets/icon/building-07.svg').ReactComponent,
  Building08: require('assets/icon/building-08.svg').ReactComponent,
  Check: require('assets/icon/check.svg').ReactComponent,
  CheckCircle: require('assets/icon/check-circle.svg').ReactComponent,
  CheckCircleBroken: require('assets/icon/check-circle-broken.svg').ReactComponent,
  CheckDone01: require('assets/icon/check-done-01.svg').ReactComponent,
  CheckDone02: require('assets/icon/check-done-02.svg').ReactComponent,
  CheckHeart: require('assets/icon/check-heart.svg').ReactComponent,
  CheckSquare: require('assets/icon/check-square.svg').ReactComponent,
  CheckSquareBroken: require('assets/icon/check-square-broken.svg').ReactComponent,
  CheckVerified01: require('assets/icon/check-verified-01.svg').ReactComponent,
  CheckVerified02: require('assets/icon/check-verified-02.svg').ReactComponent,
  CheckVerified03: require('assets/icon/check-verified-03.svg').ReactComponent,
  CloudBlank01: require('assets/icon/cloud-blank-01.svg').ReactComponent,
  CloudBlank02: require('assets/icon/cloud-blank-02.svg').ReactComponent,
  Copy01: require('assets/icon/copy-01.svg').ReactComponent,
  Copy02: require('assets/icon/copy-02.svg').ReactComponent,
  Copy03: require('assets/icon/copy-03.svg').ReactComponent,
  Copy04: require('assets/icon/copy-04.svg').ReactComponent,
  Copy05: require('assets/icon/copy-05.svg').ReactComponent,
  Copy06: require('assets/icon/copy-06.svg').ReactComponent,
  Copy07: require('assets/icon/copy-07.svg').ReactComponent,
  Divide01: require('assets/icon/divide-01.svg').ReactComponent,
  Divide02: require('assets/icon/divide-02.svg').ReactComponent,
  Divide03: require('assets/icon/divide-03.svg').ReactComponent,
  DotsGrid: require('assets/icon/dots-grid.svg').ReactComponent,
  DotsHorizontal: require('assets/icon/dots-horizontal.svg').ReactComponent,
  DotsVertical: require('assets/icon/dots-vertical.svg').ReactComponent,
  Download01: require('assets/icon/download-01.svg').ReactComponent,
  Download02: require('assets/icon/download-02.svg').ReactComponent,
  Download03: require('assets/icon/download-03.svg').ReactComponent,
  Download04: require('assets/icon/download-04.svg').ReactComponent,
  DownloadCloud01: require('assets/icon/download-cloud-01.svg').ReactComponent,
  DownloadCloud02: require('assets/icon/download-cloud-02.svg').ReactComponent,
  Edit01: require('assets/icon/edit-01.svg').ReactComponent,
  Edit02: require('assets/icon/edit-02.svg').ReactComponent,
  Edit03: require('assets/icon/edit-03.svg').ReactComponent,
  Edit04: require('assets/icon/edit-04.svg').ReactComponent,
  Edit05: require('assets/icon/edit-05.svg').ReactComponent,
  Eraser: require('assets/icon/eraser.svg').ReactComponent,
  Equal: require('assets/icon/equal.svg').ReactComponent,
  EqualNot: require('assets/icon/equal-not.svg').ReactComponent,
  Eye: require('assets/icon/eye.svg').ReactComponent,
  EyeOff: require('assets/icon/eye-off.svg').ReactComponent,
  FilterFunnel01: require('assets/icon/filter-funnel-01.svg').ReactComponent,
  FilterFunnel02: require('assets/icon/filter-funnel-02.svg').ReactComponent,
  FilterLines: require('assets/icon/filter-lines.svg').ReactComponent,
  GoogleChrome: require('assets/icon/google-chrome.svg').ReactComponent,
  Hash01: require('assets/icon/hash-01.svg').ReactComponent,
  Hash02: require('assets/icon/hash-02.svg').ReactComponent,
  Heart: require('assets/icon/heart.svg').ReactComponent,
  HeartCircle: require('assets/icon/heart-circle.svg').ReactComponent,
  HeartHand: require('assets/icon/heart-hand.svg').ReactComponent,
  HeartHexagon: require('assets/icon/heart-hexagon.svg').ReactComponent,
  HeartOctagon: require('assets/icon/heart-octagon.svg').ReactComponent,
  HeartRounded: require('assets/icon/heart-rounded.svg').ReactComponent,
  HeartSquare: require('assets/icon/heart-square.svg').ReactComponent,
  Hearts: require('assets/icon/hearts.svg').ReactComponent,
  HelpCircle: require('assets/icon/help-circle.svg').ReactComponent,
  HelpHexagon: require('assets/icon/help-hexagon.svg').ReactComponent,
  HelpOctagon: require('assets/icon/help-octagon.svg').ReactComponent,
  HelpSquare: require('assets/icon/help-square.svg').ReactComponent,
  Home01: require('assets/icon/home-01.svg').ReactComponent,
  Home02: require('assets/icon/home-02.svg').ReactComponent,
  Home03: require('assets/icon/home-03.svg').ReactComponent,
  Home04: require('assets/icon/home-04.svg').ReactComponent,
  Home05: require('assets/icon/home-05.svg').ReactComponent,
  HomeLine: require('assets/icon/home-line.svg').ReactComponent,
  HomeSmile: require('assets/icon/home-smile.svg').ReactComponent,
  InfoCircle: require('assets/icon/info-circle.svg').ReactComponent,
  InfoHexagon: require('assets/icon/info-hexagon.svg').ReactComponent,
  InfoOctagon: require('assets/icon/info-octagon.svg').ReactComponent,
  InfoSquare: require('assets/icon/info-square.svg').ReactComponent,
  LifeBuoy01: require('assets/icon/life-buoy-01.svg').ReactComponent,
  LifeBuoy02: require('assets/icon/life-buoy-02.svg').ReactComponent,
  Link01: require('assets/icon/link-01.svg').ReactComponent,
  Link02: require('assets/icon/link-02.svg').ReactComponent,
  Link03: require('assets/icon/link-03.svg').ReactComponent,
  Link04: require('assets/icon/link-04.svg').ReactComponent,
  Link05: require('assets/icon/link-05.svg').ReactComponent,
  LinkBroken01: require('assets/icon/link-broken-01.svg').ReactComponent,
  LinkBroken02: require('assets/icon/link-broken-02.svg').ReactComponent,
  LinkBroken03: require('assets/icon/link-broken-03.svg').ReactComponent,
  LinkExternal01: require('assets/icon/link-external-01.svg').ReactComponent,
  LinkExternal02: require('assets/icon/link-external-02.svg').ReactComponent,
  Loading01: require('assets/icon/loading-01.svg').ReactComponent,
  Loading02: require('assets/icon/loading-02.svg').ReactComponent,
  Loading03: require('assets/icon/loading-03.svg').ReactComponent,
  Loading: require('assets/icon/loading-01.svg').ReactComponent,
  LogIn01: require('assets/icon/log-in-01.svg').ReactComponent,
  LogIn02: require('assets/icon/log-in-02.svg').ReactComponent,
  LogIn03: require('assets/icon/log-in-03.svg').ReactComponent,
  LogIn04: require('assets/icon/log-in-04.svg').ReactComponent,
  LogOut01: require('assets/icon/log-out-01.svg').ReactComponent,
  LogOut02: require('assets/icon/log-out-02.svg').ReactComponent,
  LogOut03: require('assets/icon/log-out-03.svg').ReactComponent,
  LogOut04: require('assets/icon/log-out-04.svg').ReactComponent,
  MedicalCircle: require('assets/icon/medical-circle.svg').ReactComponent,
  MedicalCross: require('assets/icon/medical-cross.svg').ReactComponent,
  MedicalSquare: require('assets/icon/medical-square.svg').ReactComponent,
  Menu01: require('assets/icon/menu-01.svg').ReactComponent,
  Menu02: require('assets/icon/menu-02.svg').ReactComponent,
  Menu03: require('assets/icon/menu-03.svg').ReactComponent,
  Menu04: require('assets/icon/menu-04.svg').ReactComponent,
  Menu05: require('assets/icon/menu-05.svg').ReactComponent,
  Minus: require('assets/icon/minus.svg').ReactComponent,
  MinusCircle: require('assets/icon/minus-circle.svg').ReactComponent,
  MinusCircleBtn: require('assets/icon/minus-circle-btn.svg').ReactComponent,
  MinusSquare: require('assets/icon/minus-square.svg').ReactComponent,
  Percent01: require('assets/icon/percent-01.svg').ReactComponent,
  Percent02: require('assets/icon/percent-02.svg').ReactComponent,
  Percent03: require('assets/icon/percent-03.svg').ReactComponent,
  Pin01: require('assets/icon/pin-01.svg').ReactComponent,
  Pin02: require('assets/icon/pin-02.svg').ReactComponent,
  Placeholder: require('assets/icon/placeholder.svg').ReactComponent,
  Plus: require('assets/icon/plus.svg').ReactComponent,
  PlusCircle: require('assets/icon/plus-circle.svg').ReactComponent,
  PlusCircleBtn: require('assets/icon/plus-circle-btn.svg').ReactComponent,
  PlusSquare: require('assets/icon/plus-square.svg').ReactComponent,
  Save01: require('assets/icon/save-01.svg').ReactComponent,
  Save02: require('assets/icon/save-02.svg').ReactComponent,
  Save03: require('assets/icon/save-03.svg').ReactComponent,
  SearchLg: require('assets/icon/search-lg.svg').ReactComponent,
  SearchMd: require('assets/icon/search-md.svg').ReactComponent,
  SearchRefraction: require('assets/icon/search-refraction.svg').ReactComponent,
  Settings01: require('assets/icon/settings-01.svg').ReactComponent,
  Settings02: require('assets/icon/settings-02.svg').ReactComponent,
  Settings03: require('assets/icon/settings-03.svg').ReactComponent,
  Settings04: require('assets/icon/settings-04.svg').ReactComponent,
  Share01: require('assets/icon/share-01.svg').ReactComponent,
  Share02: require('assets/icon/share-02.svg').ReactComponent,
  Share03: require('assets/icon/share-03.svg').ReactComponent,
  Share04: require('assets/icon/share-04.svg').ReactComponent,
  NewCircle: require('assets/icon/new-circle.svg').ReactComponent,
  Share05: require('assets/icon/share-05.svg').ReactComponent,
  Share06: require('assets/icon/share-06.svg').ReactComponent,
  Share07: require('assets/icon/share-07.svg').ReactComponent,
  SlashCircle01: require('assets/icon/slash-circle-01.svg').ReactComponent,
  SlashCircle02: require('assets/icon/slash-circle-02.svg').ReactComponent,
  SlashDivider: require('assets/icon/slash-divider.svg').ReactComponent,
  SlashOctagon: require('assets/icon/slash-octagon.svg').ReactComponent,
  Speedometer01: require('assets/icon/speedometer-01.svg').ReactComponent,
  Speedometer02: require('assets/icon/speedometer-02.svg').ReactComponent,
  Speedometer03: require('assets/icon/speedometer-03.svg').ReactComponent,
  Speedometer04: require('assets/icon/speedometer-04.svg').ReactComponent,
  Target01: require('assets/icon/target-01.svg').ReactComponent,
  Target02: require('assets/icon/target-02.svg').ReactComponent,
  Target03: require('assets/icon/target-03.svg').ReactComponent,
  Target04: require('assets/icon/target-04.svg').ReactComponent,
  Target05: require('assets/icon/target-05.svg').ReactComponent,
  Toggle01Left: require('assets/icon/toggle-01-left.svg').ReactComponent,
  Toggle01Right: require('assets/icon/toggle-01-right.svg').ReactComponent,
  Toggle02Left: require('assets/icon/toggle-02-left.svg').ReactComponent,
  Toggle02Right: require('assets/icon/toggle-02-right.svg').ReactComponent,
  Toggle03Left: require('assets/icon/toggle-03-left.svg').ReactComponent,
  Toggle03Right: require('assets/icon/toggle-03-right.svg').ReactComponent,
  Tool01: require('assets/icon/tool-01.svg').ReactComponent,
  Tool02: require('assets/icon/tool-02.svg').ReactComponent,
  Translate01: require('assets/icon/translate-01.svg').ReactComponent,
  Translate02: require('assets/icon/translate-02.svg').ReactComponent,
  Trash01: require('assets/icon/trash-01.svg').ReactComponent,
  Trash02: require('assets/icon/trash-02.svg').ReactComponent,
  Trash03: require('assets/icon/trash-03.svg').ReactComponent,
  Trash04: require('assets/icon/trash-04.svg').ReactComponent,
  Upload01: require('assets/icon/upload-01.svg').ReactComponent,
  Upload02: require('assets/icon/upload-02.svg').ReactComponent,
  Upload03: require('assets/icon/upload-03.svg').ReactComponent,
  Upload04: require('assets/icon/upload-04.svg').ReactComponent,
  UploadCloud01: require('assets/icon/upload-cloud-01.svg').ReactComponent,
  UploadCloud02: require('assets/icon/upload-cloud-02.svg').ReactComponent,
  Virus: require('assets/icon/virus.svg').ReactComponent,
  XCircle: require('assets/icon/x-circle.svg').ReactComponent,
  XCloseLg: require('assets/icon/x-close-lg.svg').ReactComponent,
  XCloseMd: require('assets/icon/x-close-md.svg').ReactComponent,
  XSquare: require('assets/icon/x-square.svg').ReactComponent,
  CloseCircleBtn: require('assets/icon/close-circle-btn.svg').ReactComponent,
  Zap: require('assets/icon/zap.svg').ReactComponent,
  ZapCircle: require('assets/icon/zap-circle.svg').ReactComponent,
  ZapFast: require('assets/icon/zap-fast.svg').ReactComponent,
  ZapOff: require('assets/icon/zap-off.svg').ReactComponent,
  ZapSquare: require('assets/icon/zap-square.svg').ReactComponent,

  ArrowBlockDown: require('assets/icon/arrow-block-down.svg').ReactComponent,
  ArrowLeft: require('assets/icon/arrow-left.svg').ReactComponent,
  ArrowsRight: require('assets/icon/arrows-right.svg').ReactComponent,
  Expand03: require('assets/icon/expand-03.svg').ReactComponent,
  ArrowBlockLeft: require('assets/icon/arrow-block-left.svg').ReactComponent,
  ArrowNarrowDown: require('assets/icon/arrow-narrow-down.svg').ReactComponent,
  ArrowsTriangle: require('assets/icon/arrows-triangle.svg').ReactComponent,
  Expand04: require('assets/icon/expand-04.svg').ReactComponent,
  ArrowBlockRight: require('assets/icon/arrow-block-right.svg').ReactComponent,
  ArrowNarrowDownLeft: require('assets/icon/arrow-narrow-down-left.svg').ReactComponent,
  ArrowsUp: require('assets/icon/arrows-up.svg').ReactComponent,
  Expand05: require('assets/icon/expand-05.svg').ReactComponent,
  ArrowBlockUp: require('assets/icon/arrow-block-up.svg').ReactComponent,
  ArrowNarrowDownRight: require('assets/icon/arrow-narrow-down-right.svg').ReactComponent,
  ChevronDown: require('assets/icon/chevron-down.svg').ReactComponent,
  Expand06: require('assets/icon/expand-06.svg').ReactComponent,
  ArrowCircleBrokenDown: require('assets/icon/arrow-circle-broken-down.svg').ReactComponent,
  ArrowNarrowLeft: require('assets/icon/arrow-narrow-left.svg').ReactComponent,
  ChevronDownDouble: require('assets/icon/chevron-down-double.svg').ReactComponent,
  FlipBackward: require('assets/icon/flip-backward.svg').ReactComponent,
  ArrowCircleBrokenDownLeft: require('assets/icon/arrow-circle-broken-down-left.svg')
    .ReactComponent,
  ArrowNarrowRight: require('assets/icon/arrow-narrow-right.svg').ReactComponent,
  ChevronLeft: require('assets/icon/chevron-left.svg').ReactComponent,
  FlipForward: require('assets/icon/flip-forward.svg').ReactComponent,
  ArrowCircleBrokenDownRight: require('assets/icon/arrow-circle-broken-down-right.svg')
    .ReactComponent,
  ArrowNarrowUp: require('assets/icon/arrow-narrow-up.svg').ReactComponent,
  ChevronLeftDouble: require('assets/icon/chevron-left-double.svg').ReactComponent,
  Infinity: require('assets/icon/infinity.svg').ReactComponent,
  ArrowCircleBrokenLeft: require('assets/icon/arrow-circle-broken-left.svg').ReactComponent,
  ArrowNarrowUpLeft: require('assets/icon/arrow-narrow-up-left.svg').ReactComponent,
  ChevronRight: require('assets/icon/chevron-right.svg').ReactComponent,
  RefreshCcw01: require('assets/icon/refresh-ccw-01.svg').ReactComponent,
  ArrowCircleBrokenRight: require('assets/icon/arrow-circle-broken-right.svg').ReactComponent,
  ArrowNarrowUpRight: require('assets/icon/arrow-narrow-up-right.svg').ReactComponent,
  ChevronRightDouble: require('assets/icon/chevron-right-double.svg').ReactComponent,
  RefreshCcw02: require('assets/icon/refresh-ccw-02.svg').ReactComponent,
  ArrowCircleBrokenUp: require('assets/icon/arrow-circle-broken-up.svg').ReactComponent,
  ArrowRight: require('assets/icon/arrow-right.svg').ReactComponent,
  ChevronSelectorHorizontal: require('assets/icon/chevron-selector-horizontal.svg').ReactComponent,
  RefreshCcw03: require('assets/icon/refresh-ccw-03.svg').ReactComponent,
  ArrowCircleBrokenUpLeft: require('assets/icon/arrow-circle-broken-up-left.svg').ReactComponent,
  ArrowSquareDown: require('assets/icon/arrow-square-down.svg').ReactComponent,
  ChevronSelectorVertical: require('assets/icon/chevron-selector-vertical.svg').ReactComponent,
  RefreshCcw04: require('assets/icon/refresh-ccw-04.svg').ReactComponent,
  ArrowCircleBrokenUpRight: require('assets/icon/arrow-circle-broken-up-right.svg').ReactComponent,
  ArrowSquareDownLeft: require('assets/icon/arrow-square-down-left.svg').ReactComponent,
  ChevronUp: require('assets/icon/chevron-up.svg').ReactComponent,
  RefreshCcw05: require('assets/icon/refresh-ccw-05.svg').ReactComponent,
  ArrowCircleDown: require('assets/icon/arrow-circle-down.svg').ReactComponent,
  ArrowSquareDownRight: require('assets/icon/arrow-square-down-right.svg').ReactComponent,
  ChevronUpDouble: require('assets/icon/chevron-up-double.svg').ReactComponent,
  RefreshCw01: require('assets/icon/refresh-cw-01.svg').ReactComponent,
  ArrowCircleDownLeft: require('assets/icon/arrow-circle-down-left.svg').ReactComponent,
  ArrowSquareLeft: require('assets/icon/arrow-square-left.svg').ReactComponent,
  CornerDownLeft: require('assets/icon/corner-down-left.svg').ReactComponent,
  RefreshCw02: require('assets/icon/refresh-cw-02.svg').ReactComponent,
  ArrowCircleDownRight: require('assets/icon/arrow-circle-down-right.svg').ReactComponent,
  ArrowSquareRight: require('assets/icon/arrow-square-right.svg').ReactComponent,
  CornerDownRight: require('assets/icon/corner-down-right.svg').ReactComponent,
  RefreshCw03: require('assets/icon/refresh-cw-03.svg').ReactComponent,
  ArrowCircleLeft: require('assets/icon/arrow-circle-left.svg').ReactComponent,
  ArrowSquareUp: require('assets/icon/arrow-square-up.svg').ReactComponent,
  CornerLeftDown: require('assets/icon/corner-left-down.svg').ReactComponent,
  RefreshCw04: require('assets/icon/refresh-cw-04.svg').ReactComponent,
  ArrowCircleRight: require('assets/icon/arrow-circle-right.svg').ReactComponent,
  ArrowSquareUpLeft: require('assets/icon/arrow-square-up-left.svg').ReactComponent,
  CornerLeftUp: require('assets/icon/corner-left-up.svg').ReactComponent,
  RefreshCw05: require('assets/icon/refresh-cw-05.svg').ReactComponent,
  ArrowCircleUp: require('assets/icon/arrow-circle-up.svg').ReactComponent,
  ArrowSquareUpRight: require('assets/icon/arrow-square-up-right.svg').ReactComponent,
  CornerRightDown: require('assets/icon/corner-right-down.svg').ReactComponent,
  ReverseLeft: require('assets/icon/reverse-left.svg').ReactComponent,
  ArrowCircleUpLeft: require('assets/icon/arrow-circle-up-left.svg').ReactComponent,
  ArrowUp: require('assets/icon/arrow-up.svg').ReactComponent,
  CornerRightUp: require('assets/icon/corner-right-up.svg').ReactComponent,
  ReverseRight: require('assets/icon/reverse-right.svg').ReactComponent,
  ArrowCircleUpRight: require('assets/icon/arrow-circle-up-right.svg').ReactComponent,
  ArrowUpLeft: require('assets/icon/arrow-up-left.svg').ReactComponent,
  CornerUpLeft: require('assets/icon/corner-up-left.svg').ReactComponent,
  SwitchHorizontal01: require('assets/icon/switch-horizontal-01.svg').ReactComponent,
  ArrowDown: require('assets/icon/arrow-down.svg').ReactComponent,
  ArrowUpRight: require('assets/icon/arrow-up-right.svg').ReactComponent,
  CornerUpRight: require('assets/icon/corner-up-right.svg').ReactComponent,
  SwitchHorizontal02: require('assets/icon/switch-horizontal-02.svg').ReactComponent,
  ArrowDownLeft: require('assets/icon/arrow-down-left.svg').ReactComponent,
  ArrowsDown: require('assets/icon/arrows-down.svg').ReactComponent,
  Expand01: require('assets/icon/expand-01.svg').ReactComponent,
  SwitchVertical01: require('assets/icon/switch-vertical-01.svg').ReactComponent,
  ArrowDownRight: require('assets/icon/arrow-down-right.svg').ReactComponent,
  ArrowsLeft: require('assets/icon/arrows-left.svg').ReactComponent,
  Expand02: require('assets/icon/expand-02.svg').ReactComponent,
  SwitchVertical02: require('assets/icon/switch-vertical-02.svg').ReactComponent,
  ArrowDescending: require('assets/icon/arrow-descending.svg').ReactComponent,
  ArrowAscending: require('assets/icon/arrow-ascending.svg').ReactComponent,
  ArrowBlockSide: require('assets/icon/arrow-block-side.svg').ReactComponent,

  FaceContent: require('assets/icon/face-content.svg').ReactComponent,
  UserCheck02: require('assets/icon/user-check-02.svg').ReactComponent,
  UserRight01: require('assets/icon/user-right-01.svg').ReactComponent,
  UsersDown: require('assets/icon/users-down.svg').ReactComponent,
  FaceFrown: require('assets/icon/face-frown.svg').ReactComponent,
  UserCircle: require('assets/icon/user-circle.svg').ReactComponent,
  UserRight02: require('assets/icon/user-right-02.svg').ReactComponent,
  UsersEdit: require('assets/icon/users-edit.svg').ReactComponent,
  FaceHappy: require('assets/icon/face-happy.svg').ReactComponent,
  UserDown01: require('assets/icon/user-down-01.svg').ReactComponent,
  UserSquare: require('assets/icon/user-square.svg').ReactComponent,
  UsersLeft: require('assets/icon/users-left.svg').ReactComponent,
  FaceNeutral: require('assets/icon/face-neutral.svg').ReactComponent,
  UserDown02: require('assets/icon/user-down-02.svg').ReactComponent,
  UserUp01: require('assets/icon/user-up-01.svg').ReactComponent,
  UsersMinus: require('assets/icon/users-minus.svg').ReactComponent,
  FaceSad: require('assets/icon/face-sad.svg').ReactComponent,
  UserEdit: require('assets/icon/user-edit.svg').ReactComponent,
  UserUp02: require('assets/icon/user-up-02.svg').ReactComponent,
  UsersPlus: require('assets/icon/users-plus.svg').ReactComponent,
  FaceSmile: require('assets/icon/face-smile.svg').ReactComponent,
  UserLeft01: require('assets/icon/user-left-01.svg').ReactComponent,
  UserX01: require('assets/icon/user-x-01.svg').ReactComponent,
  UsersRight: require('assets/icon/users-right.svg').ReactComponent,
  FaceWink: require('assets/icon/face-wink.svg').ReactComponent,
  UserLeft02: require('assets/icon/user-left-02.svg').ReactComponent,
  UserX02: require('assets/icon/user-x-02.svg').ReactComponent,
  UsersUp: require('assets/icon/users-up.svg').ReactComponent,
  User01: require('assets/icon/user-01.svg').ReactComponent,
  UserMinus01: require('assets/icon/user-minus-01.svg').ReactComponent,
  Users01: require('assets/icon/users-01.svg').ReactComponent,
  UsersX: require('assets/icon/users-x.svg').ReactComponent,
  User02: require('assets/icon/user-02.svg').ReactComponent,
  UserMinus02: require('assets/icon/user-minus-02.svg').ReactComponent,
  Users02: require('assets/icon/users-02.svg').ReactComponent,
  User03: require('assets/icon/user-03.svg').ReactComponent,
  UserPlus01: require('assets/icon/user-plus-01.svg').ReactComponent,
  UserCheck01: require('assets/icon/user-check-01.svg').ReactComponent,
  UserPlus02: require('assets/icon/user-plus-02.svg').ReactComponent,
  UsersCheck: require('assets/icon/users-check.svg').ReactComponent,

  BarChart01: require('assets/icon/bar-chart-01.svg').ReactComponent,
  BarChartCircle02: require('assets/icon/bar-chart-circle-02.svg').ReactComponent,
  HorizontalBarChart02: require('assets/icon/horizontal-bar-chart-02.svg').ReactComponent,
  PieChart02: require('assets/icon/pie-chart-02.svg').ReactComponent,
  BarChart02: require('assets/icon/bar-chart-02.svg').ReactComponent,
  BarChartCircle03: require('assets/icon/bar-chart-circle-03.svg').ReactComponent,
  HorizontalBarChart03: require('assets/icon/horizontal-bar-chart-03.svg').ReactComponent,
  PieChart03: require('assets/icon/pie-chart-03.svg').ReactComponent,
  BarChart03: require('assets/icon/bar-chart-03.svg').ReactComponent,
  BarChartSquare01: require('assets/icon/bar-chart-square-01.svg').ReactComponent,
  LineChartDown01: require('assets/icon/line-chart-down-01.svg').ReactComponent,
  PieChart04: require('assets/icon/pie-chart-04.svg').ReactComponent,
  Polygon1: require('assets/icon/polygon-1.svg').ReactComponent,
  BarChart04: require('assets/icon/bar-chart-04.svg').ReactComponent,
  BarChartSquare02: require('assets/icon/bar-chart-square-02.svg').ReactComponent,
  LineChartDown02: require('assets/icon/line-chart-down-02.svg').ReactComponent,
  PresentationChart01: require('assets/icon/presentation-chart-01.svg').ReactComponent,
  BarChart05: require('assets/icon/bar-chart-05.svg').ReactComponent,
  BarChartSquare03: require('assets/icon/bar-chart-square-03.svg').ReactComponent,
  LineChartDown03: require('assets/icon/line-chart-down-03.svg').ReactComponent,
  PresentationChart02: require('assets/icon/presentation-chart-02.svg').ReactComponent,
  BarChart06: require('assets/icon/bar-chart-06.svg').ReactComponent,
  BarChartSquareDown: require('assets/icon/bar-chart-square-down.svg').ReactComponent,
  LineChartDown04: require('assets/icon/line-chart-down-04.svg').ReactComponent,
  PresentationChart03: require('assets/icon/presentation-chart-03.svg').ReactComponent,
  BarChart07: require('assets/icon/bar-chart-07.svg').ReactComponent,
  BarChartSquareMinus: require('assets/icon/bar-chart-square-minus.svg').ReactComponent,
  LineChartDown05: require('assets/icon/line-chart-down-05.svg').ReactComponent,
  TrendDown01: require('assets/icon/trend-down-01.svg').ReactComponent,
  BarChart08: require('assets/icon/bar-chart-08.svg').ReactComponent,
  BarChartSquarePlus: require('assets/icon/bar-chart-square-plus.svg').ReactComponent,
  LineChartUp01: require('assets/icon/line-chart-up-01.svg').ReactComponent,
  TrendDown02: require('assets/icon/trend-down-02.svg').ReactComponent,
  BarChart09: require('assets/icon/bar-chart-09.svg').ReactComponent,
  BarChartSquareUp: require('assets/icon/bar-chart-square-up.svg').ReactComponent,
  LineChartUp02: require('assets/icon/line-chart-up-02.svg').ReactComponent,
  TrendUp01: require('assets/icon/trend-up-01.svg').ReactComponent,
  BarChart10: require('assets/icon/bar-chart-10.svg').ReactComponent,
  BarLineChart: require('assets/icon/bar-line-chart.svg').ReactComponent,
  LineChartUp03: require('assets/icon/line-chart-up-03.svg').ReactComponent,
  TrendUp02: require('assets/icon/trend-up-02.svg').ReactComponent,
  BarChart11: require('assets/icon/bar-chart-11.svg').ReactComponent,
  ChartBreakoutCircle: require('assets/icon/chart-breakout-circle.svg').ReactComponent,
  LineChartUp04: require('assets/icon/line-chart-up-04.svg').ReactComponent,
  BarChart12: require('assets/icon/bar-chart-12.svg').ReactComponent,
  ChartBreakoutSquare: require('assets/icon/chart-breakout-square.svg').ReactComponent,
  LineChartUp05: require('assets/icon/line-chart-up-05.svg').ReactComponent,
  BarChartCircle01: require('assets/icon/bar-chart-circle-01.svg').ReactComponent,
  HorizontalBarChart01: require('assets/icon/horizontal-bar-chart-01.svg').ReactComponent,
  PieChart01: require('assets/icon/pie-chart-01.svg').ReactComponent,

  Annotation: require('assets/icon/annotation.svg').ReactComponent,
  Mail05: require('assets/icon/mail-05.svg').ReactComponent,
  MessagePlusCircle: require('assets/icon/message-plus-circle.svg').ReactComponent,
  PhoneCall01: require('assets/icon/phone-call-01.svg').ReactComponent,
  AnnotationAlert: require('assets/icon/annotation-alert.svg').ReactComponent,
  MessageAlertCircle: require('assets/icon/message-alert-circle.svg').ReactComponent,
  MessagePlusSquare: require('assets/icon/message-plus-square.svg').ReactComponent,
  PhoneCall02: require('assets/icon/phone-call-02.svg').ReactComponent,
  AnnotationCheck: require('assets/icon/annotation-check.svg').ReactComponent,
  MessageAlertSquare: require('assets/icon/message-alert-square.svg').ReactComponent,
  MessageQuestionCircle: require('assets/icon/message-question-circle.svg').ReactComponent,
  PhoneHangUp: require('assets/icon/phone-hang-up.svg').ReactComponent,
  AnnotationDots: require('assets/icon/annotation-dots.svg').ReactComponent,
  MessageChatCircle: require('assets/icon/message-chat-circle.svg').ReactComponent,
  MessageQuestionSquare: require('assets/icon/message-question-square.svg').ReactComponent,
  PhoneIncoming01: require('assets/icon/phone-incoming-01.svg').ReactComponent,
  AnnotationHeart: require('assets/icon/annotation-heart.svg').ReactComponent,
  MessageChatSquare: require('assets/icon/message-chat-square.svg').ReactComponent,
  MessageSmileCircle: require('assets/icon/message-smile-circle.svg').ReactComponent,
  PhoneIncoming02: require('assets/icon/phone-incoming-02.svg').ReactComponent,
  AnnotationInfo: require('assets/icon/annotation-info.svg').ReactComponent,
  MessageCheckCircle: require('assets/icon/message-check-circle.svg').ReactComponent,
  MessageSmileSquare: require('assets/icon/message-smile-square.svg').ReactComponent,
  PhoneOutgoing01: require('assets/icon/phone-outgoing-01.svg').ReactComponent,
  AnnotationPlus: require('assets/icon/annotation-plus.svg').ReactComponent,
  MessageCheckSquare: require('assets/icon/message-check-square.svg').ReactComponent,
  MessageSquare01: require('assets/icon/message-square-01.svg').ReactComponent,
  PhoneOutgoing02: require('assets/icon/phone-outgoing-02.svg').ReactComponent,
  AnnotationQuestion: require('assets/icon/annotation-question.svg').ReactComponent,
  MessageCircle01: require('assets/icon/message-circle-01.svg').ReactComponent,
  MessageSquare02: require('assets/icon/message-square-02.svg').ReactComponent,
  PhonePause: require('assets/icon/phone-pause.svg').ReactComponent,
  AnnotationX: require('assets/icon/annotation-x.svg').ReactComponent,
  MessageCircle02: require('assets/icon/message-circle-02.svg').ReactComponent,
  MessageTextCircle01: require('assets/icon/message-text-circle-01.svg').ReactComponent,
  PhonePlus: require('assets/icon/phone-plus.svg').ReactComponent,
  Inbox01: require('assets/icon/inbox-01.svg').ReactComponent,
  MessageDotsCircle: require('assets/icon/message-dots-circle.svg').ReactComponent,
  MessageTextCircle02: require('assets/icon/message-text-circle-02.svg').ReactComponent,
  PhoneX: require('assets/icon/phone-x.svg').ReactComponent,
  Inbox02: require('assets/icon/inbox-02.svg').ReactComponent,
  MessageDotsSquare: require('assets/icon/message-dots-square.svg').ReactComponent,
  MessageTextSquare01: require('assets/icon/message-text-square-01.svg').ReactComponent,
  Send01: require('assets/icon/send-01.svg').ReactComponent,
  Mail01: require('assets/icon/mail-01.svg').ReactComponent,
  MessageHeartCircle: require('assets/icon/message-heart-circle.svg').ReactComponent,
  MessageTextSquare02: require('assets/icon/message-text-square-02.svg').ReactComponent,
  Send02: require('assets/icon/send-02.svg').ReactComponent,
  Mail02: require('assets/icon/mail-02.svg').ReactComponent,
  MessageHeartSquare: require('assets/icon/message-heart-square.svg').ReactComponent,
  MessageXCircle: require('assets/icon/message-x-circle.svg').ReactComponent,
  Send03: require('assets/icon/send-03.svg').ReactComponent,
  Mail03: require('assets/icon/mail-03.svg').ReactComponent,
  MessageNotificationCircle: require('assets/icon/message-notification-circle.svg').ReactComponent,
  MessageXSquare: require('assets/icon/message-x-square.svg').ReactComponent,
  Mail04: require('assets/icon/mail-04.svg').ReactComponent,
  MessageNotificationSquare: require('assets/icon/message-notification-square.svg').ReactComponent,
  Phone: require('assets/icon/phone.svg').ReactComponent,

  AlignBottom01: require('assets/icon/align-bottom-01.svg').ReactComponent,
  DistributeSpacingVertical: require('assets/icon/distribute-spacing-vertical.svg').ReactComponent,
  GridDotsVerticalCenter: require('assets/icon/grid-dots-vertical-center.svg').ReactComponent,
  LayoutRight: require('assets/icon/layout-right.svg').ReactComponent,
  AlignBottom02: require('assets/icon/align-bottom-02.svg').ReactComponent,
  AlignBottom03: require('assets/icon/align-bottom-03.svg').ReactComponent,
  Divider: require('assets/icon/divider.svg').ReactComponent,
  IntersectCircle: require('assets/icon/intersect-circle.svg').ReactComponent,
  LayoutTop: require('assets/icon/layout-top.svg').ReactComponent,
  AlignHorizontalCentre01: require('assets/icon/align-horizontal-centre-01.svg').ReactComponent,
  FlexAlignBottom: require('assets/icon/flex-align-bottom.svg').ReactComponent,
  IntersectSquare: require('assets/icon/intersect-square.svg').ReactComponent,
  List: require('assets/icon/list.svg').ReactComponent,
  AlignHorizontalCentre02: require('assets/icon/align-horizontal-centre-02.svg').ReactComponent,
  FlexAlignLeft: require('assets/icon/flex-align-left.svg').ReactComponent,
  LayerSingle: require('assets/icon/layer-single.svg').ReactComponent,
  Maximize01: require('assets/icon/maximize-01.svg').ReactComponent,
  AlignLeft01: require('assets/icon/align-left-01.svg').ReactComponent,
  FlexAlignRight: require('assets/icon/flex-align-right.svg').ReactComponent,
  LayersThree01: require('assets/icon/layers-three-01.svg').ReactComponent,
  Maximize02: require('assets/icon/maximize-02.svg').ReactComponent,
  AlignLeft02: require('assets/icon/align-left-02.svg').ReactComponent,
  FlexAlignTop: require('assets/icon/flex-align-top.svg').ReactComponent,
  LayersThree02: require('assets/icon/layers-three-02.svg').ReactComponent,
  Minimize01: require('assets/icon/minimize-01.svg').ReactComponent,
  AlignRight01: require('assets/icon/align-right-01.svg').ReactComponent,
  Grid01: require('assets/icon/grid-01.svg').ReactComponent,
  LayersTwo01: require('assets/icon/layers-two-01.svg').ReactComponent,
  Minimize02: require('assets/icon/minimize-02.svg').ReactComponent,
  AlignRight02: require('assets/icon/align-right-02.svg').ReactComponent,
  Grid02: require('assets/icon/grid-02.svg').ReactComponent,
  LayersTwo02: require('assets/icon/layers-two-02.svg').ReactComponent,
  Rows01: require('assets/icon/rows-01.svg').ReactComponent,
  AlignTopArrow01: require('assets/icon/align-top-arrow-01.svg').ReactComponent,
  Grid03: require('assets/icon/grid-03.svg').ReactComponent,
  LayoutAlt01: require('assets/icon/layout-alt-01.svg').ReactComponent,
  Rows02: require('assets/icon/rows-02.svg').ReactComponent,
  AlignTopArrow02: require('assets/icon/align-top-arrow-02.svg').ReactComponent,
  GridDotsBlank: require('assets/icon/grid-dots-blank.svg').ReactComponent,
  LayoutAlt02: require('assets/icon/layout-alt-02.svg').ReactComponent,
  Rows03: require('assets/icon/rows-03.svg').ReactComponent,
  AlignVerticalCenter01: require('assets/icon/align-vertical-center-01.svg').ReactComponent,
  GridDotsBottom: require('assets/icon/grid-dots-bottom.svg').ReactComponent,
  GridStrokeAll: require('assets/icon/grid-stroke-all.svg').ReactComponent,
  GridStrokeOuter: require('assets/icon/grid-stroke-outer.svg').ReactComponent,
  LayoutAlt03: require('assets/icon/layout-alt-03.svg').ReactComponent,
  SpacingHeight01: require('assets/icon/spacing-height-01.svg').ReactComponent,
  AlignVerticalCenter02: require('assets/icon/align-vertical-center-02.svg').ReactComponent,
  GridDotsHorizontalCenter: require('assets/icon/grid-dots-horizontal-center.svg').ReactComponent,
  LayoutAlt04: require('assets/icon/layout-alt-04.svg').ReactComponent,
  SpacingHeight02: require('assets/icon/spacing-height-02.svg').ReactComponent,
  Columns01: require('assets/icon/columns-01.svg').ReactComponent,
  GridDotsLeft: require('assets/icon/grid-dots-left.svg').ReactComponent,
  LayoutBottom: require('assets/icon/layout-bottom.svg').ReactComponent,
  SpacingWidth01: require('assets/icon/spacing-width-01.svg').ReactComponent,
  Columns02: require('assets/icon/columns-02.svg').ReactComponent,
  GridDotsOuter: require('assets/icon/grid-dots-outer.svg').ReactComponent,
  LayoutGrid01: require('assets/icon/layout-grid-01.svg').ReactComponent,
  SpacingWidth02: require('assets/icon/spacing-width-02.svg').ReactComponent,
  Columns03: require('assets/icon/columns-03.svg').ReactComponent,
  GridDotsRight: require('assets/icon/grid-dots-right.svg').ReactComponent,
  LayoutGrid02: require('assets/icon/layout-grid-02.svg').ReactComponent,
  Table: require('assets/icon/table.svg').ReactComponent,
  DistributeSpacingHorizontal: require('assets/icon/distribute-spacing-horizontal.svg')
    .ReactComponent,
  DistributeSpacingLeft: require('assets/icon/distribute-spacing-left.svg').ReactComponent,
  DistributeSpacingRight: require('assets/icon/distribute-spacing-right.svg').ReactComponent,
  DistributeSpacingTop: require('assets/icon/distribute-spacing-top.svg').ReactComponent,
  DistributeSpacingBottom: require('assets/icon/distribute-spacing-bottom.svg').ReactComponent,
  GridDotsTop: require('assets/icon/grid-dots-top.svg').ReactComponent,
  LayoutLeft: require('assets/icon/layout-left.svg').ReactComponent,
  AlignPrettify: require('assets/icon/align-prettify.svg').ReactComponent,

  AlertCircle: require('assets/icon/alert-circle.svg').ReactComponent,
  Announcement03: require('assets/icon/announcement-03.svg').ReactComponent,
  BellOff02: require('assets/icon/bell-off-02.svg').ReactComponent,
  NotificationBox: require('assets/icon/notification-box.svg').ReactComponent,
  AlertHexagon: require('assets/icon/alert-hexagon.svg').ReactComponent,
  Bell01: require('assets/icon/bell-01.svg').ReactComponent,
  BellOff03: require('assets/icon/bell-off-03.svg').ReactComponent,
  NotificationMessage: require('assets/icon/notification-message.svg').ReactComponent,
  AlertOctagon: require('assets/icon/alert-octagon.svg').ReactComponent,
  Bell02: require('assets/icon/bell-02.svg').ReactComponent,
  BellPlus: require('assets/icon/bell-plus.svg').ReactComponent,
  NotificationText: require('assets/icon/notification-text.svg').ReactComponent,
  AlertSquare: require('assets/icon/alert-square.svg').ReactComponent,
  Bell03: require('assets/icon/bell-03.svg').ReactComponent,
  BellRinging01: require('assets/icon/bell-ringing-01.svg').ReactComponent,
  ThumbsDown: require('assets/icon/thumbs-down.svg').ReactComponent,
  AlertTriangle: require('assets/icon/alert-triangle.svg').ReactComponent,
  Bell04: require('assets/icon/bell-04.svg').ReactComponent,
  BellRinging02: require('assets/icon/bell-ringing-02.svg').ReactComponent,
  ThumbsUp: require('assets/icon/thumbs-up.svg').ReactComponent,
  Announcement01: require('assets/icon/announcement-01.svg').ReactComponent,
  BellMinus: require('assets/icon/bell-minus.svg').ReactComponent,
  BellRinging03: require('assets/icon/bell-ringing-03.svg').ReactComponent,
  Announcement02: require('assets/icon/announcement-02.svg').ReactComponent,
  BellOff01: require('assets/icon/bell-off-01.svg').ReactComponent,
  BellRinging04: require('assets/icon/bell-ringing-04.svg').ReactComponent,
  Circle: require('assets/icon/circle.svg').ReactComponent,
  Dice2: require('assets/icon/dice-2.svg').ReactComponent,
  Octagon: require('assets/icon/octagon.svg').ReactComponent,
  Star05: require('assets/icon/star-05.svg').ReactComponent,
  Cube01: require('assets/icon/cube-01.svg').ReactComponent,
  Dice4: require('assets/icon/dice-4.svg').ReactComponent,
  Pentagon: require('assets/icon/pentagon.svg').ReactComponent,
  Star06: require('assets/icon/star-06.svg').ReactComponent,
  Cube02: require('assets/icon/cube-02.svg').ReactComponent,
  Dice3: require('assets/icon/dice-3.svg').ReactComponent,
  Square: require('assets/icon/square.svg').ReactComponent,
  SquareGradient: require('assets/icon/square-gradient.svg').ReactComponent,
  SquareSolid: require('assets/icon/square-solid.svg').ReactComponent,
  Star07: require('assets/icon/star-07.svg').ReactComponent,
  Cube03: require('assets/icon/cube-03.svg').ReactComponent,
  Dice5: require('assets/icon/dice-5.svg').ReactComponent,
  Star01: require('assets/icon/star-01.svg').ReactComponent,
  Triangle: require('assets/icon/triangle.svg').ReactComponent,
  Cube04: require('assets/icon/cube-04.svg').ReactComponent,
  Dice6: require('assets/icon/dice-6.svg').ReactComponent,
  Star02: require('assets/icon/star-02.svg').ReactComponent,
  CubeOutline: require('assets/icon/cube-outline.svg').ReactComponent,
  Hexagon01: require('assets/icon/hexagon-01.svg').ReactComponent,
  Star03: require('assets/icon/star-03.svg').ReactComponent,
  Dice1: require('assets/icon/dice-1.svg').ReactComponent,
  Hexagon02: require('assets/icon/hexagon-02.svg').ReactComponent,
  Star04: require('assets/icon/star-04.svg').ReactComponent,
  Airplay: require('assets/icon/airplay.svg').ReactComponent,
  Keyboard02: require('assets/icon/keyboard-02.svg').ReactComponent,
  Play: require('assets/icon/play.svg').ReactComponent,
  Sliders03: require('assets/icon/sliders-03.svg').ReactComponent,
  Airpods: require('assets/icon/airpods.svg').ReactComponent,
  Laptop01: require('assets/icon/laptop-01.svg').ReactComponent,
  PlayCircle: require('assets/icon/play-circle.svg').ReactComponent,
  Sliders04: require('assets/icon/sliders-04.svg').ReactComponent,
  BatteryCharging01: require('assets/icon/battery-charging-01.svg').ReactComponent,
  Laptop02: require('assets/icon/laptop-02.svg').ReactComponent,
  PlaySquare: require('assets/icon/play-square.svg').ReactComponent,
  Speaker01: require('assets/icon/speaker-01.svg').ReactComponent,
  BatteryCharging02: require('assets/icon/battery-charging-02.svg').ReactComponent,
  Lightbulb01: require('assets/icon/lightbulb-01.svg').ReactComponent,
  Podcast: require('assets/icon/podcast.svg').ReactComponent,
  Speaker02: require('assets/icon/speaker-02.svg').ReactComponent,
  BatteryEmpty: require('assets/icon/battery-empty.svg').ReactComponent,
  Lightbulb02: require('assets/icon/lightbulb-02.svg').ReactComponent,
  Power01: require('assets/icon/power-01.svg').ReactComponent,
  Speaker03: require('assets/icon/speaker-03.svg').ReactComponent,
  BatteryFull: require('assets/icon/battery-full.svg').ReactComponent,
  Lightbulb03: require('assets/icon/lightbulb-03.svg').ReactComponent,
  Power02: require('assets/icon/power-02.svg').ReactComponent,
  Stop: require('assets/icon/stop.svg').ReactComponent,
  BatteryLow: require('assets/icon/battery-low.svg').ReactComponent,
  Lightbulb04: require('assets/icon/lightbulb-04.svg').ReactComponent,
  Power03: require('assets/icon/power-03.svg').ReactComponent,
  StopCircle: require('assets/icon/stop-circle.svg').ReactComponent,
  BatteryMid: require('assets/icon/battery-mid.svg').ReactComponent,
  Lightbulb05: require('assets/icon/lightbulb-05.svg').ReactComponent,
  Printer: require('assets/icon/printer.svg').ReactComponent,
  StopSquare: require('assets/icon/stop-square.svg').ReactComponent,
  BluetoothConnect: require('assets/icon/bluetooth-connect.svg').ReactComponent,
  Microphone01: require('assets/icon/microphone-01.svg').ReactComponent,
  Recording01: require('assets/icon/recording-01.svg').ReactComponent,
  Tablet01: require('assets/icon/tablet-01.svg').ReactComponent,
  BluetoothOff: require('assets/icon/bluetooth-off.svg').ReactComponent,
  Microphone02: require('assets/icon/microphone-02.svg').ReactComponent,
  Recording02: require('assets/icon/recording-02.svg').ReactComponent,
  Tablet02: require('assets/icon/tablet-02.svg').ReactComponent,
  BluetoothOn: require('assets/icon/bluetooth-on.svg').ReactComponent,
  MicrophoneOff01: require('assets/icon/microphone-off-01.svg').ReactComponent,
  Recording03: require('assets/icon/recording-03.svg').ReactComponent,
  Tv01: require('assets/icon/tv-01.svg').ReactComponent,
  BluetoothSignal: require('assets/icon/bluetooth-signal.svg').ReactComponent,
  MicrophoneOff02: require('assets/icon/microphone-off-02.svg').ReactComponent,
  Repeat01: require('assets/icon/repeat-01.svg').ReactComponent,
  Tv02: require('assets/icon/tv-02.svg').ReactComponent,
  ChromeCast: require('assets/icon/chrome-cast.svg').ReactComponent,
  Modem01: require('assets/icon/modem-01.svg').ReactComponent,
  Repeat02: require('assets/icon/repeat-02.svg').ReactComponent,
  Tv03: require('assets/icon/tv-03.svg').ReactComponent,
  Clapperboard: require('assets/icon/clapperboard.svg').ReactComponent,
  Modem02: require('assets/icon/modem-02.svg').ReactComponent,
  Repeat03: require('assets/icon/repeat-03.svg').ReactComponent,
  UsbFlashDrive: require('assets/icon/usb-flash-drive.svg').ReactComponent,
  Disc01: require('assets/icon/disc-01.svg').ReactComponent,
  Monitor01: require('assets/icon/monitor-01.svg').ReactComponent,
  Repeat04: require('assets/icon/repeat-04.svg').ReactComponent,
  VideoRecorder: require('assets/icon/video-recorder.svg').ReactComponent,
  Disc02: require('assets/icon/disc-02.svg').ReactComponent,
  Monitor02: require('assets/icon/monitor-02.svg').ReactComponent,
  Rss01: require('assets/icon/rss-01.svg').ReactComponent,
  VideoRecorderOff: require('assets/icon/video-recorder-off.svg').ReactComponent,
  FastBackward: require('assets/icon/fast-backward.svg').ReactComponent,
  Monitor03: require('assets/icon/monitor-03.svg').ReactComponent,
  Rss02: require('assets/icon/rss-02.svg').ReactComponent,
  Voicemail: require('assets/icon/voicemail.svg').ReactComponent,
  FastForward: require('assets/icon/fast-forward.svg').ReactComponent,
  Monitor04: require('assets/icon/monitor-04.svg').ReactComponent,
  Shuffle01: require('assets/icon/shuffle-01.svg').ReactComponent,
  VolumeMax: require('assets/icon/volume-max.svg').ReactComponent,
  Film01: require('assets/icon/film-01.svg').ReactComponent,
  Monitor05: require('assets/icon/monitor-05.svg').ReactComponent,
  Shuffle02: require('assets/icon/shuffle-02.svg').ReactComponent,
  VolumeMin: require('assets/icon/volume-min.svg').ReactComponent,
  Film02: require('assets/icon/film-02.svg').ReactComponent,
  Mouse: require('assets/icon/mouse.svg').ReactComponent,
  Signal01: require('assets/icon/signal-01.svg').ReactComponent,
  VolumeMinus: require('assets/icon/volume-minus.svg').ReactComponent,
  Film03: require('assets/icon/film-03.svg').ReactComponent,
  MusicNote01: require('assets/icon/music-note-01.svg').ReactComponent,
  Signal02: require('assets/icon/signal-02.svg').ReactComponent,
  VolumePlus: require('assets/icon/volume-plus.svg').ReactComponent,
  GamingPad01: require('assets/icon/gaming-pad-01.svg').ReactComponent,
  MusicNote02: require('assets/icon/music-note-02.svg').ReactComponent,
  Signal03: require('assets/icon/signal-03.svg').ReactComponent,
  VolumeX: require('assets/icon/volume-x.svg').ReactComponent,
  GamingPad02: require('assets/icon/gaming-pad-02.svg').ReactComponent,
  MusicNotePlus: require('assets/icon/music-note-plus.svg').ReactComponent,
  Simcard: require('assets/icon/simcard.svg').ReactComponent,
  Webcam01: require('assets/icon/webcam-01.svg').ReactComponent,
  HardDrive: require('assets/icon/hard-drive.svg').ReactComponent,
  PauseCircle: require('assets/icon/pause-circle.svg').ReactComponent,
  SkipBack: require('assets/icon/skip-back.svg').ReactComponent,
  Webcam02: require('assets/icon/webcam-02.svg').ReactComponent,
  Headphones01: require('assets/icon/headphones-01.svg').ReactComponent,
  PauseSquare: require('assets/icon/pause-square.svg').ReactComponent,
  SkipForward: require('assets/icon/skip-forward.svg').ReactComponent,
  Wifi: require('assets/icon/wifi.svg').ReactComponent,
  Headphones02: require('assets/icon/headphones-02.svg').ReactComponent,
  Phone01: require('assets/icon/phone-01.svg').ReactComponent,
  Sliders01: require('assets/icon/sliders-01.svg').ReactComponent,
  WifiOff: require('assets/icon/wifi-off.svg').ReactComponent,
  Keyboard01: require('assets/icon/keyboard-01.svg').ReactComponent,
  Phone02: require('assets/icon/phone-02.svg').ReactComponent,
  Sliders02: require('assets/icon/sliders-02.svg').ReactComponent,
  Youtube: require('assets/icon/youtube.svg').ReactComponent,
  Brackets: require('assets/icon/brackets.svg').ReactComponent,
  CodeSquare02: require('assets/icon/code-square-02.svg').ReactComponent,
  FolderX: require('assets/icon/folder-x.svg').ReactComponent,
  QrCode02: require('assets/icon/qr-code-02.svg').ReactComponent,
  BracketsCheck: require('assets/icon/brackets-check.svg').ReactComponent,
  Codepen: require('assets/icon/codepen.svg').ReactComponent,
  GitBranch01: require('assets/icon/git-branch-01.svg').ReactComponent,
  Server01: require('assets/icon/server-01.svg').ReactComponent,
  BracketsEllipses: require('assets/icon/brackets-ellipses.svg').ReactComponent,
  Container: require('assets/icon/container.svg').ReactComponent,
  GitBranch02: require('assets/icon/git-branch-02.svg').ReactComponent,
  Server02: require('assets/icon/server-02.svg').ReactComponent,
  BracketsMinus: require('assets/icon/brackets-minus.svg').ReactComponent,
  CpuChip01: require('assets/icon/cpu-chip-01.svg').ReactComponent,
  GitCommit: require('assets/icon/git-commit.svg').ReactComponent,
  Server03: require('assets/icon/server-03.svg').ReactComponent,
  BracketsPlus: require('assets/icon/brackets-plus.svg').ReactComponent,
  CpuChip02: require('assets/icon/cpu-chip-02.svg').ReactComponent,
  GitMerge: require('assets/icon/git-merge.svg').ReactComponent,
  Server04: require('assets/icon/server-04.svg').ReactComponent,
  BracketsSlash: require('assets/icon/brackets-slash.svg').ReactComponent,
  Data: require('assets/icon/data.svg').ReactComponent,
  GitPullRequest: require('assets/icon/git-pull-request.svg').ReactComponent,
  Server05: require('assets/icon/server-05.svg').ReactComponent,
  BracketsX: require('assets/icon/brackets-x.svg').ReactComponent,
  Database01: require('assets/icon/database-01.svg').ReactComponent,
  Package: require('assets/icon/package.svg').ReactComponent,
  Server06: require('assets/icon/server-06.svg').ReactComponent,
  Browser: require('assets/icon/browser.svg').ReactComponent,
  Database02: require('assets/icon/database-02.svg').ReactComponent,
  PackageMinus: require('assets/icon/package-minus.svg').ReactComponent,
  Terminal: require('assets/icon/terminal.svg').ReactComponent,
  Code01: require('assets/icon/code-01.svg').ReactComponent,
  Database03: require('assets/icon/database-03.svg').ReactComponent,
  PackageCheck: require('assets/icon/package-check.svg').ReactComponent,
  TerminalBrowser: require('assets/icon/terminal-browser.svg').ReactComponent,
  Code02: require('assets/icon/code-02.svg').ReactComponent,
  Dataflow01: require('assets/icon/dataflow-01.svg').ReactComponent,
  PackagePlus: require('assets/icon/package-plus.svg').ReactComponent,
  TerminalCircle: require('assets/icon/terminal-circle.svg').ReactComponent,
  CodeBrowser: require('assets/icon/code-browser.svg').ReactComponent,
  Dataflow02: require('assets/icon/dataflow-02.svg').ReactComponent,
  PackageSearch: require('assets/icon/package-search.svg').ReactComponent,
  TerminalSquare: require('assets/icon/terminal-square.svg').ReactComponent,
  CodeCircle01: require('assets/icon/code-circle-01.svg').ReactComponent,
  Dataflow03: require('assets/icon/dataflow-03.svg').ReactComponent,
  PackageX: require('assets/icon/package-x.svg').ReactComponent,
  Variable: require('assets/icon/variable.svg').ReactComponent,
  CodeCircle02: require('assets/icon/code-circle-02.svg').ReactComponent,
  Dataflow04: require('assets/icon/dataflow-04.svg').ReactComponent,
  PuzzlePiece01: require('assets/icon/puzzle-piece-01.svg').ReactComponent,
  Auto: require('assets/icon/auto#.svg').ReactComponent,
  CodeCircle03: require('assets/icon/code-circle-03.svg').ReactComponent,
  FileCode01: require('assets/icon/file-code-01.svg').ReactComponent,
  PuzzlePiece02: require('assets/icon/puzzle-piece-02.svg').ReactComponent,
  Database04: require('assets/icon/database-04.svg').ReactComponent,
  CodeSquare01: require('assets/icon/code-square-01.svg').ReactComponent,
  FileCode02: require('assets/icon/file-code-02.svg').ReactComponent,
  QrCode01: require('assets/icon/qr-code-01.svg').ReactComponent,
  File01: require('assets/icon/file-01.svg').ReactComponent,
  FileDownload01: require('assets/icon/file-download-01.svg').ReactComponent,
  FileX01: require('assets/icon/file-x-01.svg').ReactComponent,
  File02: require('assets/icon/file-02.svg').ReactComponent,
  FileDownload02: require('assets/icon/file-download-02.svg').ReactComponent,
  FileX02: require('assets/icon/file-x-02.svg').ReactComponent,
  Paperclip: require('assets/icon/paperclip.svg').ReactComponent,
  File03: require('assets/icon/file-03.svg').ReactComponent,
  FileDownload03: require('assets/icon/file-download-03.svg').ReactComponent,
  FileX03: require('assets/icon/file-x-03.svg').ReactComponent,
  Clipboard: require('assets/icon/clipboard.svg').ReactComponent,
  File04: require('assets/icon/file-04.svg').ReactComponent,
  FileHeart01: require('assets/icon/file-heart-01.svg').ReactComponent,
  FileSearch01: require('assets/icon/file-search-01.svg').ReactComponent,
  ClipboardAttachment: require('assets/icon/clipboard-attachment.svg').ReactComponent,
  File05: require('assets/icon/file-05.svg').ReactComponent,
  FileHeart02: require('assets/icon/file-heart-02.svg').ReactComponent,
  FileSearch02: require('assets/icon/file-search-02.svg').ReactComponent,
  ClipboardDownload: require('assets/icon/clipboard-download.svg').ReactComponent,
  File06: require('assets/icon/file-06.svg').ReactComponent,
  FileHeart03: require('assets/icon/file-heart-03.svg').ReactComponent,
  FileSearch03: require('assets/icon/file-search-03.svg').ReactComponent,
  ClipboardCheck: require('assets/icon/clipboard-check.svg').ReactComponent,
  File07: require('assets/icon/file-07.svg').ReactComponent,
  FileMinus01: require('assets/icon/file-minus-01.svg').ReactComponent,
  Folder: require('assets/icon/folder.svg').ReactComponent,
  ClipboardX: require('assets/icon/clipboard-x.svg').ReactComponent,
  FileAttachment01: require('assets/icon/file-attachment-01.svg').ReactComponent,
  FileMinus02: require('assets/icon/file-minus-02.svg').ReactComponent,
  FolderCheck: require('assets/icon/folder-check.svg').ReactComponent,
  ClipboardPlus: require('assets/icon/clipboard-plus.svg').ReactComponent,
  FileAttachment02: require('assets/icon/file-attachment-02.svg').ReactComponent,
  FileMinus03: require('assets/icon/file-minus-03.svg').ReactComponent,
  FolderDownload: require('assets/icon/folder-download.svg').ReactComponent,
  ClipboardMinus: require('assets/icon/clipboard-minus.svg').ReactComponent,
  FileAttachment03: require('assets/icon/file-attachment-03.svg').ReactComponent,
  FilePlus01: require('assets/icon/file-plus-01.svg').ReactComponent,
  FolderLock: require('assets/icon/folder-lock.svg').ReactComponent,
  StickerSquare: require('assets/icon/sticker-square.svg').ReactComponent,
  FileAttachment04: require('assets/icon/file-attachment-04.svg').ReactComponent,
  FilePlus02: require('assets/icon/file-plus-02.svg').ReactComponent,
  FolderMinus: require('assets/icon/folder-minus.svg').ReactComponent,
  StickerCircle: require('assets/icon/sticker-circle.svg').ReactComponent,
  FileAttachment05: require('assets/icon/file-attachment-05.svg').ReactComponent,
  FilePlus03: require('assets/icon/file-plus-03.svg').ReactComponent,
  FolderPlus: require('assets/icon/folder-plus.svg').ReactComponent,
  Box: require('assets/icon/box.svg').ReactComponent,
  FileCheck01: require('assets/icon/file-check-01.svg').ReactComponent,
  FileQuestion01: require('assets/icon/file-question-01.svg').ReactComponent,
  FolderQuestion: require('assets/icon/folder-question.svg').ReactComponent,
  FileCheck02: require('assets/icon/file-check-02.svg').ReactComponent,
  FileQuestion02: require('assets/icon/file-question-02.svg').ReactComponent,
  FolderSearch: require('assets/icon/folder-search.svg').ReactComponent,
  FileCheck03: require('assets/icon/file-check-03.svg').ReactComponent,
  FileQuestion03: require('assets/icon/file-question-03.svg').ReactComponent,
  FolderClosed: require('assets/icon/folder-closed.svg').ReactComponent,
  FileNumeric: require('assets/icon/file-numeric.svg').ReactComponent,
  FaceId: require('assets/icon/face-id.svg').ReactComponent,
  Fingerprint02: require('assets/icon/fingerprint-02.svg').ReactComponent,
  Lock04: require('assets/icon/lock-04.svg').ReactComponent,
  Scan: require('assets/icon/scan.svg').ReactComponent,
  FaceIdSquare: require('assets/icon/face-id-square.svg').ReactComponent,
  Fingerprint03: require('assets/icon/fingerprint-03.svg').ReactComponent,
  LockKeyholeCircle: require('assets/icon/lock-keyhole-circle.svg').ReactComponent,
  Shield03: require('assets/icon/shield-03.svg').ReactComponent,
  FileLock01: require('assets/icon/file-lock-01.svg').ReactComponent,
  Fingerprint04: require('assets/icon/fingerprint-04.svg').ReactComponent,
  LockKeyholeSquare: require('assets/icon/lock-keyhole-square.svg').ReactComponent,
  ShieldDollar: require('assets/icon/shield-dollar.svg').ReactComponent,
  FileLock02: require('assets/icon/file-lock-02.svg').ReactComponent,
  FolderShield: require('assets/icon/folder-shield.svg').ReactComponent,
  LockUnlocked01: require('assets/icon/lock-unlocked-01.svg').ReactComponent,
  ShieldOff: require('assets/icon/shield-off.svg').ReactComponent,
  FileLock03: require('assets/icon/file-lock-03.svg').ReactComponent,
  Key01: require('assets/icon/key-01.svg').ReactComponent,
  LockUnlocked02: require('assets/icon/lock-unlocked-02.svg').ReactComponent,
  ShieldPlus: require('assets/icon/shield-plus.svg').ReactComponent,
  FileShield01: require('assets/icon/file-shield-01.svg').ReactComponent,
  Key02: require('assets/icon/key-02.svg').ReactComponent,
  LockUnlocked03: require('assets/icon/lock-unlocked-03.svg').ReactComponent,
  ShieldTick: require('assets/icon/shield-tick.svg').ReactComponent,
  FileShield02: require('assets/icon/file-shield-02.svg').ReactComponent,
  Lock01: require('assets/icon/lock-01.svg').ReactComponent,
  LockUnlocked04: require('assets/icon/lock-unlocked-04.svg').ReactComponent,
  ShieldZap: require('assets/icon/shield-zap.svg').ReactComponent,
  FileShield03: require('assets/icon/file-shield-03.svg').ReactComponent,
  Lock02: require('assets/icon/lock-02.svg').ReactComponent,
  Passcode: require('assets/icon/passcode.svg').ReactComponent,
  Shield01: require('assets/icon/shield-01.svg').ReactComponent,
  Fingerprint01: require('assets/icon/fingerprint-01.svg').ReactComponent,
  Lock03: require('assets/icon/lock-03.svg').ReactComponent,
  PasscodeLock: require('assets/icon/passcode-lock.svg').ReactComponent,
  Shield02: require('assets/icon/shield-02.svg').ReactComponent,
  LockUnlocked05: require('assets/icon/lock-unlocked-05.svg').ReactComponent,
  Bank: require('assets/icon/bank.svg').ReactComponent,
  CreditCardEdit: require('assets/icon/credit-card-edit.svg').ReactComponent,
  CurrencyEuro: require('assets/icon/currency-euro.svg').ReactComponent,
  Sale02: require('assets/icon/sale-02.svg').ReactComponent,
  BankNote01: require('assets/icon/bank-note-01.svg').ReactComponent,
  CreditCardLock: require('assets/icon/credit-card-lock.svg').ReactComponent,
  CurrencyEuroCircle: require('assets/icon/currency-euro-circle.svg').ReactComponent,
  Sale03: require('assets/icon/sale-03.svg').ReactComponent,
  BankNote02: require('assets/icon/bank-note-02.svg').ReactComponent,
  CreditCardMinus: require('assets/icon/credit-card-minus.svg').ReactComponent,
  CurrencyPound: require('assets/icon/currency-pound.svg').ReactComponent,
  Sale04: require('assets/icon/sale-04.svg').ReactComponent,
  BankNote03: require('assets/icon/bank-note-03.svg').ReactComponent,
  CreditCardPlus: require('assets/icon/credit-card-plus.svg').ReactComponent,
  CurrencyPoundCircle: require('assets/icon/currency-pound-circle.svg').ReactComponent,
  Scales01: require('assets/icon/scales-01.svg').ReactComponent,
  Coins01: require('assets/icon/coins-01.svg').ReactComponent,
  CreditCardRefresh: require('assets/icon/credit-card-refresh.svg').ReactComponent,
  CurrencyRuble: require('assets/icon/currency-ruble.svg').ReactComponent,
  Scales02: require('assets/icon/scales-02.svg').ReactComponent,
  Coins02: require('assets/icon/coins-02.svg').ReactComponent,
  CreditCardSearch: require('assets/icon/credit-card-search.svg').ReactComponent,
  CurrencyRubleCircle: require('assets/icon/currency-ruble-circle.svg').ReactComponent,
  ShoppingBag01: require('assets/icon/shopping-bag-01.svg').ReactComponent,
  Coins03: require('assets/icon/coins-03.svg').ReactComponent,
  CreditCardShield: require('assets/icon/credit-card-shield.svg').ReactComponent,
  CurrencyRupee: require('assets/icon/currency-rupee.svg').ReactComponent,
  ShoppingBag02: require('assets/icon/shopping-bag-02.svg').ReactComponent,
  Coins04: require('assets/icon/coins-04.svg').ReactComponent,
  CreditCardUp: require('assets/icon/credit-card-up.svg').ReactComponent,
  CurrencyRupeeCircle: require('assets/icon/currency-rupee-circle.svg').ReactComponent,
  ShoppingBag03: require('assets/icon/shopping-bag-03.svg').ReactComponent,
  CoinsHand: require('assets/icon/coins-hand.svg').ReactComponent,
  CreditCardUpload: require('assets/icon/credit-card-upload.svg').ReactComponent,
  CurrencyYen: require('assets/icon/currency-yen.svg').ReactComponent,
  ShoppingCart01: require('assets/icon/shopping-cart-01.svg').ReactComponent,
  CoinsStacked01: require('assets/icon/coins-stacked-01.svg').ReactComponent,
  CreditCardX: require('assets/icon/credit-card-x.svg').ReactComponent,
  CurrencyYenCircle: require('assets/icon/currency-yen-circle.svg').ReactComponent,
  ShoppingCart02: require('assets/icon/shopping-cart-02.svg').ReactComponent,
  CoinsStacked02: require('assets/icon/coins-stacked-02.svg').ReactComponent,
  Cryptocurrency01: require('assets/icon/cryptocurrency-01.svg').ReactComponent,
  Diamond01: require('assets/icon/diamond-01.svg').ReactComponent,
  ShoppingCart03: require('assets/icon/shopping-cart-03.svg').ReactComponent,
  CoinsStacked03: require('assets/icon/coins-stacked-03.svg').ReactComponent,
  Cryptocurrency02: require('assets/icon/cryptocurrency-02.svg').ReactComponent,
  Diamond02: require('assets/icon/diamond-02.svg').ReactComponent,
  Tag01: require('assets/icon/tag-01.svg').ReactComponent,
  CoinsSwap01: require('assets/icon/coins-swap-01.svg').ReactComponent,
  Cryptocurrency03: require('assets/icon/cryptocurrency-03.svg').ReactComponent,
  Gift01: require('assets/icon/gift-01.svg').ReactComponent,
  Tag02: require('assets/icon/tag-02.svg').ReactComponent,
  CoinsSwap02: require('assets/icon/coins-swap-02.svg').ReactComponent,
  CurrencyBitcoin: require('assets/icon/currency-bitcoin.svg').ReactComponent,
  PiggyBank01: require('assets/icon/piggy-bank-01.svg').ReactComponent,
  Wallet01: require('assets/icon/wallet-01.svg').ReactComponent,
  CreditCard01: require('assets/icon/credit-card-01.svg').ReactComponent,
  CurrencyBitcoinCircle: require('assets/icon/currency-bitcoin-circle.svg').ReactComponent,
  Receipt: require('assets/icon/receipt.svg').ReactComponent,
  Wallet02: require('assets/icon/wallet-02.svg').ReactComponent,
  CreditCard02: require('assets/icon/credit-card-02.svg').ReactComponent,
  CurrencyDollar: require('assets/icon/currency-dollar.svg').ReactComponent,
  ReceiptCheck: require('assets/icon/receipt-check.svg').ReactComponent,
  Wallet03: require('assets/icon/wallet-03.svg').ReactComponent,
  CreditCardCheck: require('assets/icon/credit-card-check.svg').ReactComponent,
  CurrencyDollarCircle: require('assets/icon/currency-dollar-circle.svg').ReactComponent,
  Safe: require('assets/icon/safe.svg').ReactComponent,
  Wallet04: require('assets/icon/wallet-04.svg').ReactComponent,
  CreditCardDown: require('assets/icon/credit-card-down.svg').ReactComponent,
  CurrencyEthereum: require('assets/icon/currency-ethereum.svg').ReactComponent,
  Sale01: require('assets/icon/sale-01.svg').ReactComponent,
  CreditCardDownload: require('assets/icon/credit-card-download.svg').ReactComponent,
  CurrencyEthereumCircle: require('assets/icon/currency-ethereum-circle.svg').ReactComponent,
  Camera01: require('assets/icon/camera-01.svg').ReactComponent,
  FlashOff: require('assets/icon/flash-off.svg').ReactComponent,
  ImageLeft: require('assets/icon/image-left.svg').ReactComponent,
  ImageUserPlus: require('assets/icon/image-user-plus.svg').ReactComponent,
  Camera02: require('assets/icon/camera-02.svg').ReactComponent,
  Image01: require('assets/icon/image-01.svg').ReactComponent,
  ImagePlus: require('assets/icon/image-plus.svg').ReactComponent,
  ImageUserRight: require('assets/icon/image-user-right.svg').ReactComponent,
  Camera03: require('assets/icon/camera-03.svg').ReactComponent,
  Image02: require('assets/icon/image-02.svg').ReactComponent,
  ImageRight: require('assets/icon/image-right.svg').ReactComponent,
  ImageUserUp: require('assets/icon/image-user-up.svg').ReactComponent,
  CameraLens: require('assets/icon/camera-lens.svg').ReactComponent,
  Image03: require('assets/icon/image-03.svg').ReactComponent,
  ImageUp: require('assets/icon/image-up.svg').ReactComponent,
  ImageUserX: require('assets/icon/image-user-x.svg').ReactComponent,
  CameraOff: require('assets/icon/camera-off.svg').ReactComponent,
  Image04: require('assets/icon/image-04.svg').ReactComponent,
  ImageUser: require('assets/icon/image-user.svg').ReactComponent,
  ImageX: require('assets/icon/image-x.svg').ReactComponent,
  CameraPlus: require('assets/icon/camera-plus.svg').ReactComponent,
  Image05: require('assets/icon/image-05.svg').ReactComponent,
  ImageUserCheck: require('assets/icon/image-user-check.svg').ReactComponent,
  Colors: require('assets/icon/colors.svg').ReactComponent,
  ImageCheck: require('assets/icon/image-check.svg').ReactComponent,
  ImageUserDown: require('assets/icon/image-user-down.svg').ReactComponent,
  Flash: require('assets/icon/flash.svg').ReactComponent,
  ImageDown: require('assets/icon/image-down.svg').ReactComponent,
  ImageUserLeft: require('assets/icon/image-user-left.svg').ReactComponent,
  AlarmClock: require('assets/icon/alarm-clock.svg').ReactComponent,
  CalendarCheck02: require('assets/icon/calendar-check-02.svg').ReactComponent,
  CalendarPlus02: require('assets/icon/calendar-plus-02.svg').ReactComponent,
  ClockSnooze: require('assets/icon/clock-snooze.svg').ReactComponent,
  AlarmClockCheck: require('assets/icon/alarm-clock-check.svg').ReactComponent,
  CalendarDate: require('assets/icon/calendar-date.svg').ReactComponent,
  Clock: require('assets/icon/clock.svg').ReactComponent,
  ClockStopwatch: require('assets/icon/clock-stopwatch.svg').ReactComponent,
  AlarmClockMinus: require('assets/icon/alarm-clock-minus.svg').ReactComponent,
  CalendarHeart01: require('assets/icon/calendar-heart-01.svg').ReactComponent,
  ClockCheck: require('assets/icon/clock-check.svg').ReactComponent,
  Hourglass01: require('assets/icon/hourglass-01.svg').ReactComponent,
  AlarmClockOff: require('assets/icon/alarm-clock-off.svg').ReactComponent,
  CalendarHeart02: require('assets/icon/calendar-heart-02.svg').ReactComponent,
  ClockFastForward: require('assets/icon/clock-fast-forward.svg').ReactComponent,
  Hourglass02: require('assets/icon/hourglass-02.svg').ReactComponent,
  AlarmClockPlus: require('assets/icon/alarm-clock-plus.svg').ReactComponent,
  CalendarMinus01: require('assets/icon/calendar-minus-01.svg').ReactComponent,
  ClockPlus: require('assets/icon/clock-plus.svg').ReactComponent,
  Hourglass03: require('assets/icon/hourglass-03.svg').ReactComponent,
  Calendar: require('assets/icon/calendar.svg').ReactComponent,
  CalendarMinus02: require('assets/icon/calendar-minus-02.svg').ReactComponent,
  ClockRefresh: require('assets/icon/clock-refresh.svg').ReactComponent,
  WatchCircle: require('assets/icon/watch-circle.svg').ReactComponent,
  CalendarCheck01: require('assets/icon/calendar-check-01.svg').ReactComponent,
  CalendarPlus01: require('assets/icon/calendar-plus-01.svg').ReactComponent,
  ClockRewind: require('assets/icon/clock-rewind.svg').ReactComponent,
  WatchSquare: require('assets/icon/watch-square.svg').ReactComponent,
  AlignCenter: require('assets/icon/align-center.svg').ReactComponent,
  Cursor02: require('assets/icon/cursor-02.svg').ReactComponent,
  LetterSpacing01: require('assets/icon/letter-spacing-01.svg').ReactComponent,
  RightIndent02: require('assets/icon/right-indent-02.svg').ReactComponent,
  AlignJustify: require('assets/icon/align-justify.svg').ReactComponent,
  Cursor03: require('assets/icon/cursor-03.svg').ReactComponent,
  LetterSpacing02: require('assets/icon/letter-spacing-02.svg').ReactComponent,
  RollerBrush: require('assets/icon/roller-brush.svg').ReactComponent,
  AlignLeft: require('assets/icon/align-left.svg').ReactComponent,
  Cursor04: require('assets/icon/cursor-04.svg').ReactComponent,
  LineHeight: require('assets/icon/line-height.svg').ReactComponent,
  Scale01: require('assets/icon/scale-01.svg').ReactComponent,
  AlignRight: require('assets/icon/align-right.svg').ReactComponent,
  CursorBox: require('assets/icon/cursor-box.svg').ReactComponent,
  MagicWand01: require('assets/icon/magic-wand-01.svg').ReactComponent,
  Scale02: require('assets/icon/scale-02.svg').ReactComponent,
  Attachment01: require('assets/icon/attachment-01.svg').ReactComponent,
  CursorClick01: require('assets/icon/cursor-click-01.svg').ReactComponent,
  MagicWand02: require('assets/icon/magic-wand-02.svg').ReactComponent,
  Scale03: require('assets/icon/scale-03.svg').ReactComponent,
  Attachment02: require('assets/icon/attachment-02.svg').ReactComponent,
  CursorClick02: require('assets/icon/cursor-click-02.svg').ReactComponent,
  Move: require('assets/icon/move.svg').ReactComponent,
  Scissors01: require('assets/icon/scissors-01.svg').ReactComponent,
  BezierCurve01: require('assets/icon/bezier-curve-01.svg').ReactComponent,
  Delete: require('assets/icon/delete.svg').ReactComponent,
  Paint: require('assets/icon/paint.svg').ReactComponent,
  Scissors02: require('assets/icon/scissors-02.svg').ReactComponent,
  BezierCurve02: require('assets/icon/bezier-curve-02.svg').ReactComponent,
  Dotpoints01: require('assets/icon/dotpoints-01.svg').ReactComponent,
  PaintPour: require('assets/icon/paint-pour.svg').ReactComponent,
  ScissorsCut01: require('assets/icon/scissors-cut-01.svg').ReactComponent,
  BezierCurve03: require('assets/icon/bezier-curve-03.svg').ReactComponent,
  Dotpoints02: require('assets/icon/dotpoints-02.svg').ReactComponent,
  Palette: require('assets/icon/palette.svg').ReactComponent,
  ScissorsCut02: require('assets/icon/scissors-cut-02.svg').ReactComponent,
  Bold01: require('assets/icon/bold-01.svg').ReactComponent,
  Drop: require('assets/icon/drop.svg').ReactComponent,
  ParagraphSpacing: require('assets/icon/paragraph-spacing.svg').ReactComponent,
  Skew: require('assets/icon/skew.svg').ReactComponent,
  Bold02: require('assets/icon/bold-02.svg').ReactComponent,
  Dropper: require('assets/icon/dropper.svg').ReactComponent,
  PenTool01: require('assets/icon/pen-tool-01.svg').ReactComponent,
  Strikethrough01: require('assets/icon/strikethrough-01.svg').ReactComponent,
  Brush01: require('assets/icon/brush-01.svg').ReactComponent,
  Feather: require('assets/icon/feather.svg').ReactComponent,
  PenTool02: require('assets/icon/pen-tool-02.svg').ReactComponent,
  StrikethroughSquare: require('assets/icon/strikethrough-square.svg').ReactComponent,
  Brush02: require('assets/icon/brush-02.svg').ReactComponent,
  Brush03: require('assets/icon/brush-03.svg').ReactComponent,
  Figma: require('assets/icon/figma.svg').ReactComponent,
  PenToolMinus: require('assets/icon/pen-tool-minus.svg').ReactComponent,
  TextInput: require('assets/icon/text-input.svg').ReactComponent,
  CircleCut: require('assets/icon/circle-cut.svg').ReactComponent,
  Hand: require('assets/icon/hand.svg').ReactComponent,
  Pencil01: require('assets/icon/pencil-01.svg').ReactComponent,
  Transform: require('assets/icon/transform.svg').ReactComponent,
  CodeSnippet01: require('assets/icon/code-snippet-01.svg').ReactComponent,
  Heading01: require('assets/icon/heading-01.svg').ReactComponent,
  Pencil02: require('assets/icon/pencil-02.svg').ReactComponent,
  Type01: require('assets/icon/type-01.svg').ReactComponent,
  CodeSnippet02: require('assets/icon/code-snippet-02.svg').ReactComponent,
  Heading02: require('assets/icon/heading-02.svg').ReactComponent,
  PencilLine: require('assets/icon/pencil-line.svg').ReactComponent,
  Type02: require('assets/icon/type-02.svg').ReactComponent,
  HeadingSquare: require('assets/icon/heading-square.svg').ReactComponent,
  Perspective01: require('assets/icon/perspective-01.svg').ReactComponent,
  TypeSquare: require('assets/icon/type-square.svg').ReactComponent,
  Command: require('assets/icon/command.svg').ReactComponent,
  ImageIndentLeft: require('assets/icon/image-indent-left.svg').ReactComponent,
  Perspective02: require('assets/icon/perspective-02.svg').ReactComponent,
  TypeStrikethrough01: require('assets/icon/type-strikethrough-01.svg').ReactComponent,
  Contrast01: require('assets/icon/contrast-01.svg').ReactComponent,
  ImageIndentRight: require('assets/icon/image-indent-right.svg').ReactComponent,
  Pilcrow01: require('assets/icon/pilcrow-01.svg').ReactComponent,
  TypeStrikethrough02: require('assets/icon/type-strikethrough-02.svg').ReactComponent,
  Contrast02: require('assets/icon/contrast-02.svg').ReactComponent,
  Italic01: require('assets/icon/italic-01.svg').ReactComponent,
  Pilcrow02: require('assets/icon/pilcrow-02.svg').ReactComponent,
  Underline01: require('assets/icon/underline-01.svg').ReactComponent,
  Contrast03: require('assets/icon/contrast-03.svg').ReactComponent,
  Italic02: require('assets/icon/italic-02.svg').ReactComponent,
  PilcrowSquare: require('assets/icon/pilcrow-square.svg').ReactComponent,
  Underline02: require('assets/icon/underline-02.svg').ReactComponent,
  Crop01: require('assets/icon/crop-01.svg').ReactComponent,
  ItalicSquare: require('assets/icon/italic-square.svg').ReactComponent,
  Reflect01: require('assets/icon/reflect-01.svg').ReactComponent,
  UnderlineSquare: require('assets/icon/underline-square.svg').ReactComponent,
  Crop02: require('assets/icon/crop-02.svg').ReactComponent,
  LeftIndent01: require('assets/icon/left-indent-01.svg').ReactComponent,
  Reflect02: require('assets/icon/reflect-02.svg').ReactComponent,
  ZoomIn: require('assets/icon/zoom-in.svg').ReactComponent,
  Cursor01: require('assets/icon/cursor-01.svg').ReactComponent,
  LeftIndent02: require('assets/icon/left-indent-02.svg').ReactComponent,
  RightIndent01: require('assets/icon/right-indent-01.svg').ReactComponent,
  ZoomOut: require('assets/icon/zoom-out.svg').ReactComponent,
  Bus: require('assets/icon/bus.svg').ReactComponent,
  Globe01: require('assets/icon/globe-01.svg').ReactComponent,
  MarkerPin01: require('assets/icon/marker-pin-01.svg').ReactComponent,
  Rocket01: require('assets/icon/rocket-01.svg').ReactComponent,
  Car01: require('assets/icon/car-01.svg').ReactComponent,
  Globe02: require('assets/icon/globe-02.svg').ReactComponent,
  MarkerPin02: require('assets/icon/marker-pin-02.svg').ReactComponent,
  Rocket02: require('assets/icon/rocket-02.svg').ReactComponent,
  Car02: require('assets/icon/car-02.svg').ReactComponent,
  Globe03: require('assets/icon/globe-03.svg').ReactComponent,
  MarkerPin03: require('assets/icon/marker-pin-03.svg').ReactComponent,
  Route: require('assets/icon/route.svg').ReactComponent,
  Compass01: require('assets/icon/compass-01.svg').ReactComponent,
  Globe04: require('assets/icon/globe-04.svg').ReactComponent,
  MarkerPin04: require('assets/icon/marker-pin-04.svg').ReactComponent,
  Ticket01: require('assets/icon/ticket-01.svg').ReactComponent,
  Compass02: require('assets/icon/compass-02.svg').ReactComponent,
  Globe05: require('assets/icon/globe-05.svg').ReactComponent,
  MarkerPin05: require('assets/icon/marker-pin-05.svg').ReactComponent,
  Ticket02: require('assets/icon/ticket-02.svg').ReactComponent,
  Compass03: require('assets/icon/compass-03.svg').ReactComponent,
  Globe06: require('assets/icon/globe-06.svg').ReactComponent,
  MarkerPin06: require('assets/icon/marker-pin-06.svg').ReactComponent,
  Train: require('assets/icon/train.svg').ReactComponent,
  Flag01: require('assets/icon/flag-01.svg').ReactComponent,
  Luggage01: require('assets/icon/luggage-01.svg').ReactComponent,
  NavigationBarPointer01: require('assets/icon/navigation-pointer-01.svg').ReactComponent,
  Tram: require('assets/icon/tram.svg').ReactComponent,
  Flag02: require('assets/icon/flag-02.svg').ReactComponent,
  Luggage02: require('assets/icon/luggage-02.svg').ReactComponent,
  NavigationBarPointer02: require('assets/icon/navigation-pointer-02.svg').ReactComponent,
  Truck01: require('assets/icon/truck-01.svg').ReactComponent,
  Flag03: require('assets/icon/flag-03.svg').ReactComponent,
  Luggage03: require('assets/icon/luggage-03.svg').ReactComponent,
  NavigationBarPointerOff01: require('assets/icon/navigation-pointer-off-01.svg').ReactComponent,
  Truck02: require('assets/icon/truck-02.svg').ReactComponent,
  Flag04: require('assets/icon/flag-04.svg').ReactComponent,
  Map01: require('assets/icon/map-01.svg').ReactComponent,
  NavigationBarPointerOff02: require('assets/icon/navigation-pointer-off-02.svg').ReactComponent,
  Flag05: require('assets/icon/flag-05.svg').ReactComponent,
  Map02: require('assets/icon/map-02.svg').ReactComponent,
  Passport: require('assets/icon/passport.svg').ReactComponent,
  Flag06: require('assets/icon/flag-06.svg').ReactComponent,
  Mark: require('assets/icon/mark.svg').ReactComponent,
  Plane: require('assets/icon/plane.svg').ReactComponent,
  Cloud01: require('assets/icon/cloud-01.svg').ReactComponent,
  CloudSnowing02: require('assets/icon/cloud-snowing-02.svg').ReactComponent,
  Moon02: require('assets/icon/moon-02.svg').ReactComponent,
  Sunset: require('assets/icon/sunset.svg').ReactComponent,
  Cloud02: require('assets/icon/cloud-02.svg').ReactComponent,
  CloudSun01: require('assets/icon/cloud-sun-01.svg').ReactComponent,
  MoonEclipse: require('assets/icon/moon-eclipse.svg').ReactComponent,
  Thermometer01: require('assets/icon/thermometer-01.svg').ReactComponent,
  Cloud03: require('assets/icon/cloud-03.svg').ReactComponent,
  CloudSun02: require('assets/icon/cloud-sun-02.svg').ReactComponent,
  MoonStar: require('assets/icon/moon-star.svg').ReactComponent,
  Thermometer02: require('assets/icon/thermometer-02.svg').ReactComponent,
  CloudLightning: require('assets/icon/cloud-lightning.svg').ReactComponent,
  CloudSun03: require('assets/icon/cloud-sun-03.svg').ReactComponent,
  Snowflake01: require('assets/icon/snowflake-01.svg').ReactComponent,
  Thermometer03: require('assets/icon/thermometer-03.svg').ReactComponent,
  CloudMoon: require('assets/icon/cloud-moon.svg').ReactComponent,
  Droplets01: require('assets/icon/droplets-01.svg').ReactComponent,
  Snowflake02: require('assets/icon/snowflake-02.svg').ReactComponent,
  ThermometerCold: require('assets/icon/thermometer-cold.svg').ReactComponent,
  CloudOff: require('assets/icon/cloud-off.svg').ReactComponent,
  Droplets02: require('assets/icon/droplets-02.svg').ReactComponent,
  Stars01: require('assets/icon/stars-01.svg').ReactComponent,
  ThermometerWarm: require('assets/icon/thermometer-warm.svg').ReactComponent,
  CloudRaining01: require('assets/icon/cloud-raining-01.svg').ReactComponent,
  Droplets03: require('assets/icon/droplets-03.svg').ReactComponent,
  Stars02: require('assets/icon/stars-02.svg').ReactComponent,
  Umbrella01: require('assets/icon/umbrella-01.svg').ReactComponent,
  CloudRaining02: require('assets/icon/cloud-raining-02.svg').ReactComponent,
  Hurricane01: require('assets/icon/hurricane-01.svg').ReactComponent,
  Stars03: require('assets/icon/stars-03.svg').ReactComponent,
  Umbrella02: require('assets/icon/umbrella-02.svg').ReactComponent,
  CloudRaining03: require('assets/icon/cloud-raining-03.svg').ReactComponent,
  Hurricane02: require('assets/icon/hurricane-02.svg').ReactComponent,
  Sun: require('assets/icon/sun.svg').ReactComponent,
  Umbrella03: require('assets/icon/umbrella-03.svg').ReactComponent,
  CloudRaining04: require('assets/icon/cloud-raining-04.svg').ReactComponent,
  Hurricane03: require('assets/icon/hurricane-03.svg').ReactComponent,
  SunSetting01: require('assets/icon/sun-setting-01.svg').ReactComponent,
  Waves: require('assets/icon/waves.svg').ReactComponent,
  CloudRaining05: require('assets/icon/cloud-raining-05.svg').ReactComponent,
  Lightning01: require('assets/icon/lightning-01.svg').ReactComponent,
  SunSetting02: require('assets/icon/sun-setting-02.svg').ReactComponent,
  Wind01: require('assets/icon/wind-01.svg').ReactComponent,
  CloudRaining06: require('assets/icon/cloud-raining-06.svg').ReactComponent,
  Lightning02: require('assets/icon/lightning-02.svg').ReactComponent,
  SunSetting03: require('assets/icon/sun-setting-03.svg').ReactComponent,
  Wind02: require('assets/icon/wind-02.svg').ReactComponent,
  CloudSnowing01: require('assets/icon/cloud-snowing-01.svg').ReactComponent,
  Moon01: require('assets/icon/moon-01.svg').ReactComponent,
  Sunrise: require('assets/icon/sunrise.svg').ReactComponent,
  Wind03: require('assets/icon/wind-03.svg').ReactComponent,
  Atom01: require('assets/icon/atom-01.svg').ReactComponent,
  Beaker01: require('assets/icon/beaker-01.svg').ReactComponent,
  Certificate01: require('assets/icon/certificate-01.svg').ReactComponent,
  GraduationHat02: require('assets/icon/graduation-hat-02.svg').ReactComponent,
  Atom02: require('assets/icon/atom-02.svg').ReactComponent,
  Beaker02: require('assets/icon/beaker-02.svg').ReactComponent,
  Certificate02: require('assets/icon/certificate-02.svg').ReactComponent,
  Microscope: require('assets/icon/microscope.svg').ReactComponent,
  Award01: require('assets/icon/award-01.svg').ReactComponent,
  BookClosed: require('assets/icon/book-closed.svg').ReactComponent,
  Compass: require('assets/icon/compass.svg').ReactComponent,
  Ruler: require('assets/icon/ruler.svg').ReactComponent,
  Award02: require('assets/icon/award-02.svg').ReactComponent,
  BookOpen01: require('assets/icon/book-open-01.svg').ReactComponent,
  Glasses01: require('assets/icon/glasses-01.svg').ReactComponent,
  Stand: require('assets/icon/stand.svg').ReactComponent,
  Award03: require('assets/icon/award-03.svg').ReactComponent,
  BookOpen02: require('assets/icon/book-open-02.svg').ReactComponent,
  Glasses02: require('assets/icon/glasses-02.svg').ReactComponent,
  Telescope: require('assets/icon/telescope.svg').ReactComponent,
  Award04: require('assets/icon/award-04.svg').ReactComponent,
  Briefcase01: require('assets/icon/briefcase-01.svg').ReactComponent,
  GlobeSlated01: require('assets/icon/globe-slated-01.svg').ReactComponent,
  Trophy01: require('assets/icon/trophy-01.svg').ReactComponent,
  Award05: require('assets/icon/award-05.svg').ReactComponent,
  Briefcase02: require('assets/icon/briefcase-02.svg').ReactComponent,
  GlobeSlated02: require('assets/icon/globe-slated-02.svg').ReactComponent,
  Trophy02: require('assets/icon/trophy-02.svg').ReactComponent,
  Backpack: require('assets/icon/backpack.svg').ReactComponent,
  Calculator: require('assets/icon/calculator.svg').ReactComponent,
  GraduationHat01: require('assets/icon/graduation-hat-01.svg').ReactComponent,
  AlignHorizontalCentre03: require('assets/icon/align-horizontal-centre-03.svg').ReactComponent,
  AlignLeft03: require('assets/icon/align-left-03.svg').ReactComponent,
  AlignRight03: require('assets/icon/align-right-03.svg').ReactComponent,
  AlignTopArrow03: require('assets/icon/align-top-arrow-03.svg').ReactComponent,
  AlignVerticalCenter03: require('assets/icon/align-vertical-center-03.svg').ReactComponent,
  ArrowAngular: require('assets/icon/arrow-angular.svg').ReactComponent,
  ArrowCircle: require('assets/icon/arrow-circle.svg').ReactComponent,
  ArrowHorizontal: require('assets/icon/arrow-horizontal.svg').ReactComponent,
  ArrowLine: require('assets/icon/arrow-line.svg').ReactComponent,
  ArrowNone: require('assets/icon/arrow-none.svg').ReactComponent,
  ArrowRound: require('assets/icon/arrow-round.svg').ReactComponent,
  ArrowSquare: require('assets/icon/arrow-square.svg').ReactComponent,
  ArrowTriangle: require('assets/icon/arrow-triangle.svg').ReactComponent,
  ArrowVertical: require('assets/icon/arrow-vertical.svg').ReactComponent,
  CoordinateX: require('assets/icon/coordinate-x.svg').ReactComponent,
  CoordinateY: require('assets/icon/coordinate-y.svg').ReactComponent,
  DashCapFlat: require('assets/icon/dash-cap-flat.svg').ReactComponent,
  DashCapRound: require('assets/icon/dash-cap-round.svg').ReactComponent,
  DashCapSquare: require('assets/icon/dash-cap-square.svg').ReactComponent,
  JoinBevel: require('assets/icon/join-bevel.svg').ReactComponent,
  JoinMiter: require('assets/icon/join-miter.svg').ReactComponent,
  JoinRound: require('assets/icon/join-round.svg').ReactComponent,
  ParagraphSpacing02: require('assets/icon/paragraph-spacing-02.svg').ReactComponent,
  Stroke02: require('assets/icon/stroke-02.svg').ReactComponent,
  StrokeDash: require('assets/icon/stroke-dash.svg').ReactComponent,
  StrokeSolid: require('assets/icon/stroke-solid.svg').ReactComponent,
  Stroke: require('assets/icon/stroke.svg').ReactComponent,
  StackedColumn: require('assets/icon/stacked-column.svg').ReactComponent,
  FullStackedColumn: require('assets/icon/100%-stacked-column.svg').ReactComponent,
  ClusteredBar: require('assets/icon/clustered-bar.svg').ReactComponent,
  StackedBar: require('assets/icon/stacked-bar.svg').ReactComponent,
  FullStackedBar: require('assets/icon/100%-stacked-bar.svg').ReactComponent,
  ClusteredColumn: require('assets/icon/clustered-column.svg').ReactComponent,
  StackedLine: require('assets/icon/stacked-line.svg').ReactComponent,
  FullStackedLine: require('assets/icon/100%-stacked-line.svg').ReactComponent,
  Combo: require('assets/icon/combo.svg').ReactComponent,
  Line: require('assets/icon/line.svg').ReactComponent,
  Doughnut: require('assets/icon/doughnut.svg').ReactComponent,
  Pie: require('assets/icon/pie.svg').ReactComponent,
  Funnel: require('assets/icon/funnel.svg').ReactComponent,
  Geo: require('assets/icon/geo.svg').ReactComponent,
  Radar: require('assets/icon/rader.svg').ReactComponent,
  Rose: require('assets/icon/rose.svg').ReactComponent,
  Sunburst: require('assets/icon/sunburst.svg').ReactComponent,
  StrokeNone: require('assets/icon/stroke-none.svg').ReactComponent,
  StrokeArrow: require('assets/icon/stroke-arrow.svg').ReactComponent,
  StrokeTriangle: require('assets/icon/stroke-triangle.svg').ReactComponent,
  StrokeCircle: require('assets/icon/stroke-circle.svg').ReactComponent,
  StrokeSquare: require('assets/icon/stroke-square.svg').ReactComponent,
  StrokeRound: require('assets/icon/stroke-round.svg').ReactComponent,
  StrokeAngular: require('assets/icon/stroke-angular.svg').ReactComponent,
  Area: require('assets/icon/area.svg').ReactComponent,
  StackedArea: require('assets/icon/stacked-area.svg').ReactComponent,
  FullStackedArea: require('assets/icon/100%-stacked-area.svg').ReactComponent,
  Scatter: require('assets/icon/scatter.svg').ReactComponent,
  Treemap: require('assets/icon/treemap.svg').ReactComponent,
  Gauge: require('assets/icon/gauge.svg').ReactComponent,
  Table02: require('assets/icon/table-02.svg').ReactComponent,
  MatricTable: require('assets/icon/matric-table.svg').ReactComponent,
  SummaryCard: require('assets/icon/summary-card.svg').ReactComponent,
  ContextSelector: require('assets/icon/context-selector.svg').ReactComponent,
  Angle: require('assets/icon/angle.svg').ReactComponent,
  ChevronSelectorHorizontal02: require('assets/icon/chevron-selector-horizontal-02.svg')
    .ReactComponent,
  ChevronSelectorVertical02: require('assets/icon/chevron-selector-vertical-02.svg').ReactComponent,
  Ratio43: require('assets/icon/43_ratio.svg').ReactComponent,
  Ratio169: require('assets/icon/169_ratio.svg').ReactComponent,
  Ratio219: require('assets/icon/219_ratio.svg').ReactComponent,
  A4Horizontal: require('assets/icon/a4_horizontal.svg').ReactComponent,
  A4Vertical: require('assets/icon/a4_vertical.svg').ReactComponent,
  BarWeight: require('assets/icon/bar-weight.svg').ReactComponent,
  Superscript: require('assets/icon/superscript.svg').ReactComponent,
  Subscript: require('assets/icon/subscript.svg').ReactComponent,
  NumberedList: require('assets/icon/numbered-list.svg').ReactComponent,
  LetteredList: require('assets/icon/lettered-list.svg').ReactComponent,
  Titlecase: require('assets/icon/titlecase.svg').ReactComponent,
  Lowercase: require('assets/icon/lowercase.svg').ReactComponent,
  Uppercase: require('assets/icon/uppercase.svg').ReactComponent,
  BulletedList: require('assets/icon/bulleted-list.svg').ReactComponent,
  Award: require('assets/icon/award.svg').ReactComponent,
  Databases04: require('assets/icon/databases-04.svg').ReactComponent,
  AI01: require('assets/icon/ai-01.svg').ReactComponent,
  AI02: require('assets/icon/ai-02.svg').ReactComponent,
  ArrowNextDown: require('assets/icon/arrow-next-down.svg').ReactComponent,
  Blur: require('assets/icon/blur.svg').ReactComponent,
  BarBottom: require('assets/icon/bar-bottom.svg').ReactComponent,
  BarMiddle: require('assets/icon/bar-middle.svg').ReactComponent,
  BarOutside: require('assets/icon/bar-outside.svg').ReactComponent,
  BarTop: require('assets/icon/bar-top.svg').ReactComponent,
  BarNone: require('assets/icon/bar-none.svg').ReactComponent,
  LineBottom: require('assets/icon/line-bottom.svg').ReactComponent,
  LineCenter: require('assets/icon/line-center.svg').ReactComponent,
  LineRotate: require('assets/icon/line-rotate.svg').ReactComponent,
  LineTop: require('assets/icon/line-top.svg').ReactComponent,
  LineNone: require('assets/icon/line-none.svg').ReactComponent,
  PieOutside: require('assets/icon/pie-outside.svg').ReactComponent,
  PieInside: require('assets/icon/pie-inside.svg').ReactComponent,
  PieNone: require('assets/icon/pie-none.svg').ReactComponent,
  ComboOutline: require('assets/icon/combo-outline.svg').ReactComponent,
  ComboBottomTop: require('assets/icon/combo-bottom-top.svg').ReactComponent,
  ComboCenterBottom: require('assets/icon/combo-center-bottom.svg').ReactComponent,
  ComboNone: require('assets/icon/combo-none.svg').ReactComponent,
  LinkExternal: require('assets/icon/link-external.svg').ReactComponent,
  Close: require('assets/icon/close.svg').ReactComponent,
  LeftLookup: require('assets/icon/left-lookup.svg').ReactComponent,
  RightLookup: require('assets/icon/right-lookup.svg').ReactComponent,
  InnerLookup: require('assets/icon/inner-lookup.svg').ReactComponent,
  OuterLookup: require('assets/icon/outer-lookup.svg').ReactComponent,
  ParagraphWrap: require('assets/icon/paragraph-wrap.svg').ReactComponent,
};
